import React, { useContext, createContext, useRef, memo, useState, useCallback, useEffect, useReducer } from "react";
import { useTranslation, initReactI18next } from "react-i18next";
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { styled, useTheme, createTheme } from "@mui/material/styles";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import InputLabel from "@mui/material/InputLabel";
import Typography$1 from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import Checkbox from "@mui/material/Checkbox";
import { grey, lightGreen, red } from "@mui/material/colors";
import Tooltip from "@mui/material/Tooltip";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import { useQuery } from "@tanstack/react-query";
import { Typography, Link, Paper as Paper$1 } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiscord, faGithub } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import * as htmlToImage from "html-to-image";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { BroadcastChannel } from "broadcast-channel";
import i18n, { t } from "i18next";
import { default as default2 } from "i18next";
import ReactGA from "react-ga4";
import { koKR, enUS, DataGrid, GridToolbarContainer, GridToolbarFilterButton } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import useMediaQuery from "@mui/material/useMediaQuery";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import styled$1 from "@emotion/styled";
import Alert from "@mui/material/Alert";
import Switch from "@mui/material/Switch";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ImageIcon from "@mui/icons-material/Image";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import axios from "axios";
import LanguageDetector from "i18next-browser-languagedetector";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a)
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps)
      for (b in a = c.defaultProps, a)
        void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React$1 = React;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const GlobalSettingContext = React.createContext(void 0);
function useGlobalSettingContext() {
  const context = useContext(GlobalSettingContext);
  if (typeof context === "undefined") {
    throw new Error("GlobalSettingContext must be within GlobalSettingProvider");
  }
  return context;
}
const CustomAnchor = styled("a")({
  width: "100%"
});
function Donation() {
  const { t: t2, i18n: i18n2 } = useTranslation();
  const { globalSetting } = useGlobalSettingContext();
  const donationImgName = globalSetting.darkTheme === "on" ? i18n2.language === "ko" ? "toonation_b18" : "toonation_b19" : i18n2.language === "ko" ? "toonation_b13" : "toonation_b14";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    List,
    {
      subheader: /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubheader, { disableSticky: true, children: t2("common.donation") }),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { sx: { padding: "8px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CustomAnchor, { href: "https://toon.at/donate/637883567462544456", target: "_blank", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box,
        {
          component: "img",
          sx: { width: "inherit" },
          src: `https://cdn.jsdelivr.net/npm/twitch-badge-collector-cc@0.0.70/dist/donation/${donationImgName}.gif`
        }
      ) }) })
    }
  );
}
const AlertContext = createContext(void 0);
function useAlertContext() {
  const context = useContext(AlertContext);
  if (typeof context === "undefined") {
    throw new Error("AlertContext must be within AlertProvider");
  }
  return context;
}
const ChannelInfoContext = React.createContext(void 0);
function useChannelInfoContext() {
  const context = useContext(ChannelInfoContext);
  if (typeof context === "undefined") {
    throw new Error("ChannelInfoContext must be within ChannelInfoProvider");
  }
  return context;
}
const UserColorContext = createContext({});
const ChatStyle = styled("div")(({ theme }) => ({
  padding: "4px 14px 4px 16px",
  verticalAlign: "middle",
  color: theme.palette.text.primary,
  overflowWrap: "anywhere"
}));
function ChatStyleComp(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ChatStyle, { className: "chat", sx: {
    textDecoration: props.removed ? "line-through" : "none"
  }, children: props.children });
}
function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  let max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0;
  let s, l = (max + min) / 2;
  if (max == min) {
    h = s = 0;
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return [h, s, l];
}
function hue2rgb(p, q, t2) {
  if (t2 < 0)
    t2 += 1;
  if (t2 > 1)
    t2 -= 1;
  if (t2 < 1 / 6)
    return p + (q - p) * 6 * t2;
  if (t2 < 1 / 2)
    return q;
  if (t2 < 2 / 3)
    return p + (q - p) * (2 / 3 - t2) * 6;
  return p;
}
function hslToRgb(h, s, l) {
  let r, g, b;
  if (s == 0) {
    r = g = b = l;
  } else {
    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return [r * 255, g * 255, b * 255];
}
function getNewBrightnessColor(rgbcode, brightness) {
  let hex = convertHexCodeToDecArray(rgbcode), HSL = rgbToHsl(hex[0], hex[1], hex[2]), RGB;
  RGB = hslToRgb(HSL[0], HSL[1], brightness / 100);
  rgbcode = "#" + convertToTwoDigitHexCodeFromDecimal(RGB[0]) + convertToTwoDigitHexCodeFromDecimal(RGB[1]) + convertToTwoDigitHexCodeFromDecimal(RGB[2]);
  return rgbcode;
}
function useReadableColor(username, color) {
  const { globalSetting } = useGlobalSettingContext();
  const userColorContext = useContext(UserColorContext);
  const targetContrast = useRef(4);
  const bgColor = useTheme().colors.remoteBgColor;
  const getColor = () => {
    let _color = resolveColor(userColorContext.current, username, color);
    const isDarkTheme = globalSetting.darkTheme === "on";
    const ctr = contrast(_color, bgColor);
    if (ctr <= 4) {
      const rgb = convertHexCodeToDecArray(_color);
      const hsl = rgbToHsl(rgb[0], rgb[1], rgb[2]);
      let light = Math.floor(hsl[2] * 100);
      if (isDarkTheme) {
        for (let i = 0; i < 10; i++) {
          light = light + 9 + (targetContrast.current - ctr);
          _color = getNewBrightnessColor(_color, light);
          if (contrast(_color, bgColor) >= 4)
            break;
        }
      } else {
        for (let i = 0; i < 10; i++) {
          light = light - 9 + (targetContrast.current - ctr);
          _color = getNewBrightnessColor(_color, light);
          if (contrast(_color, bgColor) >= 4)
            break;
        }
      }
    }
    return _color;
  };
  return { getColor };
}
const color_list = [
  "#FF0000",
  "#0000FF",
  "#008000",
  "#B22222",
  "#FF7F50",
  "#9ACD32",
  "#FF4500",
  "#2E8B57",
  "#DAA520",
  "#D2691E",
  "#5F9EA0",
  "#1E90FF",
  "#FF69B4",
  "#8A2BE2",
  "#00FF7F"
];
function resolveColor(colorMap, name, color) {
  let resolvedColor = colorMap.get(name);
  if (resolvedColor) {
    if (color && resolvedColor !== color) {
      resolvedColor = color;
      colorMap.set(name, resolvedColor);
    }
  } else {
    if (!color) {
      const rndIdx = Math.floor(Math.random() * color_list.length);
      color = color_list[rndIdx];
    }
    colorMap.set(name, color);
    resolvedColor = color;
  }
  return resolvedColor;
}
function convertToTwoDigitHexCodeFromDecimal(decimal) {
  var code = Math.round(decimal).toString(16);
  code.length > 1 || (code = "0" + code);
  return code;
}
function convertHexCodeToDecArray(hex) {
  let r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
}
function luminance(r, g, b) {
  var a = [r, g, b].map(function(v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
function contrast(rgb1, rgb2) {
  let hex1 = convertHexCodeToDecArray(rgb1);
  let hex2 = convertHexCodeToDecArray(rgb2);
  let lum1 = luminance(hex1[0], hex1[1], hex1[2]);
  let lum2 = luminance(hex2[0], hex2[1], hex2[2]);
  let brightest = Math.max(lum1, lum2);
  let darkest = Math.min(lum1, lum2);
  return (brightest + 0.05) / (darkest + 0.05);
}
const TwitchAPIContext = createContext(void 0);
function useTwitchAPIContext() {
  const context = useContext(TwitchAPIContext);
  if (typeof context === "undefined") {
    throw new Error("TwitchAPIContext must be within TwitchAPIProvider");
  }
  return context;
}
let nanoid = (size = 21) => crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
  byte &= 63;
  if (byte < 36) {
    id += byte.toString(36);
  } else if (byte < 62) {
    id += (byte - 26).toString(36).toUpperCase();
  } else if (byte > 62) {
    id += "-";
  } else {
    id += "_";
  }
  return id;
}, "");
function trim_hash(str) {
  let c1 = "";
  if (str && str !== "") {
    c1 = str[0] === "#" ? str.substring(1) : str;
  }
  return c1;
}
function getDefaultArrayFilter() {
  return {
    category: "name",
    id: nanoid(),
    type: "include",
    value: ""
  };
}
function getSubscriberBadgeTier(badge) {
  if (typeof badge === "undefined" || !badge)
    return;
  const badgeArr = badge.split("/");
  if (badgeArr[0] !== "subscriber")
    return;
  const month = badgeArr[1];
  if (typeof month === "undefined")
    return;
  const monthLen = month.length;
  return monthLen === 4 ? month[0] : monthLen === 1 || monthLen === 2 ? "1" : "";
}
function badgeUuidFromURL(url) {
  let badge_uuid = "";
  try {
    badge_uuid = new URL(url).pathname.split("/")[3];
  } catch (e) {
    return badge_uuid;
  }
  return badge_uuid;
}
function getRandomString() {
  return Math.random().toString(36).substring(2, 12);
}
function validateTwitchUsername(name) {
  return /^[a-zA-Z0-9_]{4,25}$/.test(name);
}
function getRandomArbitrary(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}
function getLocalStorageObject(key) {
  const obj = localStorage.getItem(key);
  return obj ? JSON.parse(obj) : null;
}
function getErrorMessage(error) {
  if (error instanceof Error)
    return error.message;
  return String(error);
}
function getFilterByPlatform(platform, filters) {
  return filters.filter((filter2) => filter2.platform === platform);
}
function arrayFilterEqual(a, b) {
  return Object.keys(a).length === Object.keys(b).length && Object.keys(a).every((p) => {
    if (p === "id") {
      return true;
    } else {
      return a[p] === b[p];
    }
  });
}
function arrayFiltersEqual(a, b) {
  return a.length === b.length && a.every((o, idx) => arrayFilterEqual(o, b[idx]));
}
const objectsEqual = (o1, o2) => Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every((p) => o1[p] === o2[p]);
const arraysEqual = (a1, a2) => a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));
function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayFilterEqual,
  arrayFiltersEqual,
  arraysEqual,
  badgeUuidFromURL,
  getDefaultArrayFilter,
  getErrorMessage,
  getFilterByPlatform,
  getLocalStorageObject,
  getRandomArbitrary,
  getRandomString,
  getSubscriberBadgeTier,
  inIframe,
  objectsEqual,
  trim_hash,
  validateTwitchUsername
}, Symbol.toStringTag, { value: "Module" }));
function UserTitle(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "subtitle1", sx: { fontWeight: "bold" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link,
    {
      href: `https://www.twitch.tv/${props.loginName}`,
      color: "inherit",
      underline: "none",
      target: "_blank",
      children: `${props.displayName} (${props.loginName})`
    }
  ) });
}
function Profile(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Avatar, { src: props.profileImgUrl }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "column", children: typeof props.children === "undefined" ? /* @__PURE__ */ jsxRuntimeExports.jsx(UserTitle, { displayName: props.displayName, loginName: props.loginName }) : props.children })
  ] });
}
function UserDetail(props) {
  const userFollows = props.userFollows;
  const badgeInfo = props.badgeInfo;
  const badgesRaw = props.badgesRaw;
  const { t: t2 } = useTranslation();
  let tier = "";
  if (typeof badgesRaw !== "undefined" && badgesRaw && badgesRaw !== "") {
    const badges = badgesRaw.split(",");
    const subBadge = badges.find((b) => b.split("/")[0] === "subscriber");
    tier = getSubscriberBadgeTier(subBadge) || "";
  }
  const getFollowedDate = (userFollows2) => {
    if (typeof userFollows2 === "undefined" || !userFollows2)
      return;
    if (userFollows2.data.length <= 0)
      return;
    return new Intl.DateTimeFormat("default", { dateStyle: "long" }).format(new Date(userFollows2.data[0].followed_at));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Profile, { profileImgUrl: props.profileImgUrl, displayName: props.displayName, loginName: props.loginName, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(UserTitle, { displayName: props.displayName, loginName: props.loginName }),
    userFollows && typeof userFollows !== "undefined" && userFollows.data.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", children: `${t2("common.followSince", { date: getFollowedDate(userFollows) })}` }) : null,
    badgeInfo && typeof badgeInfo !== "undefined" && tier && tier !== "" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "body2", children: `${t2("common.tier")} ${tier}, ${t2("common.subscribeSince", { month: badgeInfo.subscriber })}` }) : null
  ] });
}
const ModalBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  position: "absolute",
  top: "50%",
  left: "50%",
  width: "80%",
  maxWidth: 300,
  transform: "translate(-50%, -50%)",
  padding: "8px"
}));
const common$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ModalBox
}, Symbol.toStringTag, { value: "Module" }));
const Chat = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  let loginName = "";
  const msgType = props.msg.type;
  if (msgType === "message" || msgType === "announcement") {
    loginName = props.msg.userstate.username;
  } else if (msgType === "userNotice") {
    loginName = props.msg.userstate.login;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ChatStyleComp, { removed: props.msg.removed, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChatTimeStamp,
      {
        isReplay: props.msg.replay,
        tmiSentTs: (_a = props.msg.userstate) == null ? void 0 : _a["tmi-sent-ts"]
      },
      (_b = props.msg.userstate) == null ? void 0 : _b["tmi-sent-ts"]
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Badges,
      {
        badgesRaw: (_c = props.msg.userstate) == null ? void 0 : _c["badges-raw"],
        badgeInfo: (_d = props.msg.userstate) == null ? void 0 : _d["badge-info"]
      },
      (_e = props.msg.userstate) == null ? void 0 : _e["badges-raw"]
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Author,
      {
        loginName,
        badgesRaw: (_f = props.msg.userstate) == null ? void 0 : _f["badges-raw"],
        badgeInfo: (_g = props.msg.userstate) == null ? void 0 : _g["badge-info"],
        displayName: props.msg.userstate["display-name"] || "",
        msgType: props.msg.userstate["message-type"],
        defaultColor: props.msg.userstate.color
      },
      loginName
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Message,
      {
        message: props.msg.message,
        bits: (_h = props.msg.userstate) == null ? void 0 : _h.bits,
        emotes: (_i = props.msg.userstate) == null ? void 0 : _i.emotes,
        messageType: (_j = props.msg.userstate) == null ? void 0 : _j["message-type"],
        messageId: (_k = props.msg.userstate) == null ? void 0 : _k["msg-id"]
      }
    )
  ] });
};
const TimeStampStyle = styled("span")({
  display: "inline-flex",
  alignItems: "center",
  marginRight: "5px",
  color: "#ababab",
  verticalAlign: "middle"
});
const ChatTimeStamp = memo((props) => {
  const { globalSetting } = useGlobalSettingContext();
  let date;
  let hours, minutes;
  let ts = props.tmiSentTs;
  if (ts) {
    if (props.isReplay) {
      date = /* @__PURE__ */ new Date(0);
      date.setSeconds(parseInt(ts));
    } else {
      date = new Date(parseInt(ts));
    }
  } else {
    date = /* @__PURE__ */ new Date();
  }
  hours = ((date.getHours() + 11) % 12 + 1).toString();
  minutes = date.getMinutes().toString();
  minutes = minutes.length === 1 ? "0" + minutes : minutes;
  let res = "";
  if (props.isReplay && typeof ts !== "undefined") {
    if (parseInt(ts) < 3600) {
      res = date.toISOString().substring(14, 19);
    } else {
      res = date.toISOString().substring(11, 19);
    }
  } else {
    res = hours + ":" + minutes;
  }
  if (globalSetting.chatTime === "off") {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tooltip,
    {
      placement: "top",
      arrow: true,
      title: date.toLocaleString(),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(TimeStampStyle, { className: "chat-sent-ts", children: res })
    }
  );
});
const BadgeStyle = styled("span")({
  display: "inline-flex",
  verticalAlign: "inherit",
  ".chat-badge": {
    display: "inline-block",
    marginRight: "4px",
    verticalAlign: "baseline"
  }
});
const Badges = memo((props) => {
  const { channelInfoObject } = useChannelInfoContext();
  const globalBadges = channelInfoObject.globalBadges;
  const channelBadges = channelInfoObject.channelBadges;
  const badgesRaw = props.badgesRaw;
  props.badgeInfo;
  useTranslation();
  if (!badgesRaw || typeof badgesRaw === "undefined" || badgesRaw === "")
    return null;
  let badgesArr = badgesRaw.split(",");
  if (!channelBadges || !globalBadges) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("span", {});
  }
  const badges = badgesArr.reduce(function(result, badge) {
    badge.split("/");
    const bg = channelBadges.get(badge) || globalBadges.get(badge);
    if (typeof bg !== "undefined") {
      result.push(
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "chat-badge",
            src: bg.image_url_1x,
            srcSet: `${bg.image_url_1x} 1x, ${bg.image_url_2x} 2x, ${bg.image_url_4x} 4x`,
            alt: "Chat Badge"
          },
          bg.image_url_1x
        )
      );
    }
    return result;
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BadgeStyle, { className: "badges", children: badges });
});
const AuthorStyle = styled("span")(({ theme }) => ({
  color: theme.palette.text.primary,
  verticalAlign: "inherit",
  cursor: "pointer",
  ".chat-author-disp": {
    fontWeight: "700",
    marginRight: "4px"
  }
}));
const Author = memo((props) => {
  const loginName = props.loginName;
  const displayName = props.displayName;
  const msgType = props.msgType;
  const defaultColor = props.defaultColor;
  const [color, setColor] = React.useState(defaultColor);
  const [openModal, setOpenModal] = React.useState(false);
  const { getColor } = useReadableColor(loginName, defaultColor);
  const { channelInfo, channel: channel2 } = useChannelInfoContext();
  const { globalSetting } = useGlobalSettingContext();
  const twitchAPI2 = useTwitchAPIContext();
  const handleModalOpen = () => setOpenModal(true);
  const handleModalClose = () => setOpenModal(false);
  const badgesRaw = props.badgesRaw;
  const badgeInfo = props.badgeInfo;
  let loginNameSpan = null;
  let separator = null;
  const { data: ChannelUser, isSuccess: isChannelUserSuccess } = useQuery(
    ["User", channel2],
    () => twitchAPI2.fetchUser(channel2.type, channel2.value),
    {
      enabled: loginName !== "" && typeof channel2 !== "undefined" && channel2 && openModal
    }
  );
  const { data: User, isSuccess: isUserSuccess } = useQuery(
    ["User", loginName],
    () => twitchAPI2.fetchUser("login", loginName),
    {
      enabled: loginName !== "" && openModal
    }
  );
  const { data: UsersFollows, isSuccess: isUsersFollowsSuccess } = useQuery(
    ["UsersFollows", loginName, channel2 == null ? void 0 : channel2.value],
    () => twitchAPI2.fetchUsersFollows(User.data[0].id, ChannelUser.data[0].id),
    {
      enabled: isUserSuccess && isChannelUserSuccess && typeof User !== "undefined" && typeof ChannelUser !== "undefined" && User && ChannelUser && User.data.length > 0 && ChannelUser.data.length > 0 && channel2 && openModal
    }
  );
  if (loginName && loginName !== displayName.toLowerCase()) {
    loginNameSpan = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: `(${loginName})` });
  }
  separator = msgType !== "action" ? ": " : " ";
  React.useEffect(() => {
    setColor(getColor());
  }, [globalSetting.darkTheme]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(AuthorStyle, { className: "author", sx: { color }, onClick: handleModalOpen, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "chat-author-disp", children: displayName }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "chat-author-login", children: loginNameSpan }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "chat-message-separator", children: separator })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Modal,
      {
        open: openModal,
        onClose: handleModalClose,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBox, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "space-between", spacing: 1, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { sx: { margin: "8px" }, children: User && isUsersFollowsSuccess ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            UserDetail,
            {
              userFollows: UsersFollows,
              profileImgUrl: User.data[0].profile_image_url,
              displayName: User.data[0].display_name,
              loginName: User.data[0].login,
              badgesRaw,
              badgeInfo
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            Stack,
            {
              justifyContent: "center",
              alignContent: "center",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {})
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { onClick: handleModalClose }) })
        ] }) })
      }
    )
  ] });
});
const MessageContainerStyle = styled("span")(({ theme }) => ({
  verticalAlign: "inherit",
  color: theme.palette.text.primary,
  ".action": {
    fontStyle: "italic"
  },
  ".highlighted-message": {
    color: grey[900],
    fontWeight: "bold",
    padding: "2px",
    backgroundColor: theme.palette.warning.main
  }
}));
const EmoticonContainer = styled("div")({
  overflowWrap: "anywhere",
  boxSizing: "border-box",
  border: "0",
  font: "inherit",
  padding: "0",
  margin: "-.5rem 0",
  verticalAlign: "middle",
  alignItems: "center",
  cursor: "pointer",
  display: "inline-flex",
  fontStyle: "normal",
  height: "1.75rem",
  justifyContent: "center",
  outline: "none",
  pointerEvents: "all",
  width: "1.75rem"
});
const EmoticonContainerWithTooltip = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tooltip,
    {
      title: props.emoteCode,
      arrow: true,
      placement: "top",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmoticonContainer, { children: props.children })
    },
    props.emoteCode
  );
};
const Message = memo((props) => {
  const { channelInfoObject } = useChannelInfoContext();
  const links = resolveLink(props.message);
  const motes = resolveMotes(
    props.message,
    props.bits,
    props.emotes,
    channelInfoObject.cheermotes,
    channelInfoObject.emotesets
  );
  const objectInfo = [...links, ...motes];
  objectInfo.sort((a, b) => a.idx[0] - b.idx[0]);
  const res = [];
  let key = 0;
  const highlight = "highlighted-message";
  const classes = [
    props.messageType === "action" ? "action" : "",
    props.messageId === highlight ? highlight : ""
  ].join(" ");
  if (objectInfo.length === 0) {
    res.push(/* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: props.message }, key++));
  }
  for (let i = 0; i < objectInfo.length; i++) {
    const info = objectInfo[i];
    if (i === 0 && info.idx[0] !== 0) {
      res.push(/* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: props.message.substring(0, info.idx[0]) }, key++));
    }
    if (info.type === "emote") {
      const emoteRes = info.value;
      const emote_link = `https://static-cdn.jtvnw.net/emoticons/v2/${emoteRes.id}/default/dark`;
      res.push(
        /* @__PURE__ */ jsxRuntimeExports.jsx(EmoticonContainerWithTooltip, { emoteCode: emoteRes.code, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "emoticon",
            src: `${emote_link}/1.0`,
            alt: "",
            srcSet: `${emote_link}/1.0 1x, ${emote_link}/2.0 2x, ${emote_link}/3.0 4x`
          }
        ) }, key++)
      );
    } else if (info.type === "cheermote") {
      const prefix = info.value.prefix;
      const bits = info.value.bits;
      const min_bits = getMinBits(bits);
      const tier = getTierByMinBits(prefix, min_bits, channelInfoObject.cheermotes);
      const links2 = tier.images.dark.animated;
      const tier_color = tier.color;
      const style = {
        color: tier_color
      };
      res.push(
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "bits-amount", style, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(EmoticonContainerWithTooltip, { emoteCode: `${prefix}${bits}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "emoticon", src: links2[1], alt: "", srcSet: `${links2[0]} 1x, ${links2[1]} 2x, ${links2[2]} 4x` }) }),
          bits.toString()
        ] }, key++)
      );
    } else if (info.type === "link") {
      const msg = props.message.substring(info.idx[0], info.idx[1] + 1);
      res.push(
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: msg, target: "_blank", rel: "noreferrer", children: msg }) }, key++)
      );
    }
    if (objectInfo.length - 1 === i) {
      if (info.idx[1] < props.message.length - 1) {
        res.push(
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: props.message.substring(info.idx[1] + 1, props.message.length) }, key++)
        );
      }
    } else {
      const info_next = objectInfo[i + 1];
      res.push(
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: props.message.substring(info.idx[1] + 1, info_next.idx[0]) }, key++)
      );
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MessageContainerStyle, { className: "chat-message", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classes, children: res }) });
});
function resolveMotes(message, bits, emotes, cheerMotes, emoteSets) {
  if (!message)
    return [];
  const res = [];
  const words = message.split(" ");
  let lastWordEndIdx = 0;
  const emote = emotes || {};
  const emoteEmpty = Object.keys(emote).length === 0 && Object.getPrototypeOf(emote) === Object.prototype;
  if (!emoteEmpty) {
    Object.keys(emote).forEach((emoteId) => {
      for (let idxStr of emote[emoteId]) {
        const idxArr = idxStr.split("-").map((e) => parseInt(e));
        res.push({
          type: "emote",
          value: {
            id: emoteId,
            code: message.slice(idxArr[0], idxArr[1] + 1)
          },
          idx: idxStr.split("-").map((e) => parseInt(e))
        });
      }
    });
  }
  for (let w = 0; w < words.length; w++) {
    const word = words[w];
    const idx = [lastWordEndIdx, lastWordEndIdx + word.length - 1];
    const cheer = resolveCheermote(word, cheerMotes);
    if (bits && cheer !== null) {
      res.push({ type: "cheermote", value: cheer, idx });
    } else if (emoteEmpty && emoteSets && emoteSets.has(word)) {
      const emote_id = emoteSets.get(word).id;
      res.push({ type: "emote", value: { id: emote_id, code: word }, idx });
    }
    lastWordEndIdx = lastWordEndIdx + word.length + 1;
  }
  return res;
}
function resolveCheermote(cheerText, cheerMotes) {
  const bits_regex = /([1-9]+[0-9]*)$/;
  const cheer = cheerText.split(bits_regex);
  return cheerMotes.has(cheer[0]) ? { prefix: cheer[0], bits: cheer[1] } : null;
}
const linkRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/gi;
function resolveLink(link_text) {
  const arr = [];
  let match;
  while ((match = linkRegex.exec(link_text)) !== null) {
    arr.push({ type: "link", idx: [match.index, match.index + linkRegex.lastIndex], value: "" });
  }
  return arr;
}
function getMinBits(bits) {
  let min_bits = 0;
  if (bits >= 1 && bits <= 99) {
    min_bits = 1;
  } else if (bits >= 100 && bits <= 999) {
    min_bits = 100;
  } else if (bits >= 1e3 && bits <= 4999) {
    min_bits = 1e3;
  } else if (bits >= 5e3 && bits <= 9999) {
    min_bits = 5e3;
  } else if (bits >= 1e4) {
    min_bits = 1e4;
  }
  return min_bits;
}
function getTierByMinBits(prefix, min_bits, cheerMotes) {
  const tiers = cheerMotes.get(prefix);
  for (let t2 of tiers) {
    if (min_bits === t2.min_bits) {
      return t2;
    }
  }
}
const AnnouncementStyle = styled("div")(({ theme }) => ({
  backgroundColor: theme.colors.bgColor_2,
  margin: "4px 0 4px 0",
  width: "100%",
  ".chat": {
    marginLeft: "-8px"
  }
}));
const AnnouncementTitle = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  backgroundColor: theme.colors.bgColor_3,
  color: theme.palette.text.primary,
  height: "1rem",
  fontWeight: "bold",
  padding: "8px 8px 8px 10px"
}));
function AnnouncementContainer(props) {
  const colors = {
    PRIMARY: "#9146FF",
    BLUE: "#00D6D6",
    GREEN: "#00DB84",
    ORANGE: "#FFB31A",
    PURPLE: "#9146FF"
  };
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    AnnouncementStyle,
    {
      sx: {
        borderLeft: `${colors[props.borderColor]} solid 8px`,
        borderRight: `${colors[props.borderColor]} solid 8px`
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(AnnouncementTitle, { direction: "column", className: "announcement-title", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t2("common.announcement") }) }),
        props.children
      ]
    }
  );
}
const UserNoticeStyle = styled("div")(({ theme }) => ({
  backgroundColor: theme.colors.bgColor_2,
  borderLeft: `${theme.palette.info.main} solid 4px`,
  margin: "4px 0 4px 0",
  width: "100%",
  ".usernotice-message": {
    justifyContent: "center",
    backgroundColor: theme.colors.bgColor_3,
    color: theme.colors.textColor_1,
    padding: "8px"
  },
  ".chat": {
    marginLeft: "-4px"
  }
}));
function UserNoticeContainer(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(UserNoticeStyle, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "column", className: "usernotice-message", sx: {
      justifyContent: "center",
      padding: "8px"
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: props.sysMsg }) }),
    props.children
  ] });
}
const SystemMessageStyle = styled("div")(({ theme }) => ({
  width: "100%",
  ".system-msg__message": {
    color: theme.palette.text.secondary
  }
}));
function SystemMessageContainer(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ChatStyleComp, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SystemMessageStyle, { className: "system-msg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "system-msg__message", children: props.msg }) }) });
}
const CustomCheckBox = styled(Checkbox)({
  marginLeft: "16px",
  padding: "0"
});
const MessageWrapperComp = styled(Stack)({
  width: "100%"
});
function MessageWrapper(props) {
  const [checked, setChecked] = React.useState(false);
  React.useEffect(() => {
    setChecked(props.selected || false);
  }, [props.selected]);
  const handleChange = (e) => {
    if (!props.setMessageList)
      return;
    props.setMessageList((list) => {
      const newList = [...list];
      for (let i = 0; i < newList.length; i++) {
        const msg = newList[i];
        if (msg.id === props.messageId) {
          msg.selected = !checked;
        }
      }
      return newList;
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(MessageWrapperComp, { direction: "row", className: `message-wrapper ${props.soc ? "soc" : ""}`, children: [
    props.selectable ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      CustomCheckBox,
      {
        checked,
        name: "select-chat",
        className: "chat-chbox",
        onChange: handleChange
      }
    ) : null,
    props.children
  ] });
}
const ChatContainerStyle = styled(Stack)(({ theme }) => ({
  flex: "1",
  overflow: "auto",
  height: "100%",
  ".soc": {
    backgroundColor: theme.colors.bgColor_3
  }
}));
const ChatSelectorContainer = styled(Stack)({
  paddingTop: "8px",
  fontSize: ".9rem",
  justifyContent: "space-between"
});
function ChatContainer(props) {
  const { globalSetting } = useGlobalSettingContext();
  const messagesEndRef = React.useRef(null);
  const chatContainerRef = React.useRef(null);
  const isBottom = React.useRef(true);
  const scrollToBottom = () => {
    if (isBottom.current) {
      if (messagesEndRef.current && chatContainerRef.current) {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }
    }
  };
  const handleScroll = React.useCallback((e) => {
    e.stopPropagation();
    isBottom.current = e.currentTarget.scrollTop + e.currentTarget.clientHeight >= e.currentTarget.scrollHeight - 100;
  }, []);
  React.useEffect(() => {
    scrollToBottom();
  }, [props.messageList]);
  React.useEffect(() => {
    scrollToBottom();
  }, [props.playerTime]);
  const onCheckboxChange = (e) => {
    const checked = e.target.checked;
    if (!props.setMessageList)
      return;
    props.setMessageList((list) => {
      const newList = [...list];
      for (let i = 0; i < newList.length; i++) {
        const msg = newList[i];
        msg.selected = checked;
      }
      return newList;
    });
  };
  const messageList = props.messageList ? props.messageList.map((msg) => {
    var _a;
    if (msg.replay && props.playerTime) {
      const chatTime = parseInt((_a = msg.userstate) == null ? void 0 : _a["tmi-sent-ts"]);
      if (chatTime >= props.playerTime) {
        return;
      }
    }
    if (typeof props.onlySelected !== "undefined" && props.onlySelected) {
      if (!msg.selected) {
        return;
      }
    }
    const userstate = msg.userstate;
    const chat2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Chat, { msg }, msg.id);
    let res = null;
    if (msg.type === "announcement") {
      res = /* @__PURE__ */ jsxRuntimeExports.jsx(
        AnnouncementContainer,
        {
          borderColor: userstate ? userstate["msg-param-color"] : "PRIMARY",
          children: chat2
        },
        msg.id
      );
    } else if (msg.type === "userNotice") {
      const message = userstate ? userstate["system-msg"] : msg.message;
      res = /* @__PURE__ */ jsxRuntimeExports.jsx(UserNoticeContainer, { sysMsg: message, children: chat2 }, msg.id);
    } else if (msg.type === "system") {
      res = /* @__PURE__ */ jsxRuntimeExports.jsx(SystemMessageContainer, { msg: msg.message }, msg.id);
    } else {
      res = chat2;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(MessageWrapper, { selectable: props.selectable, selected: msg.selected || false, messageId: msg.id, setMessageList: props.setMessageList, soc: msg.soc, children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: res }) }, msg.id);
  }) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    props.messageList && props.messageList.length > 0 && props.selectable ? /* @__PURE__ */ jsxRuntimeExports.jsx(ChatSelectorContainer, { direction: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox,
      {
        name: "select-all-message",
        className: "chat-chbox",
        id: "select-all",
        onChange: onCheckboxChange,
        sx: { marginLeft: "16px", padding: "0" }
      }
    ) }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChatContainerStyle,
      {
        direction: "column",
        ref: chatContainerRef,
        className: `scroller chat-list ${props.type} font-size-${globalSetting.chatFontSize || "default"}`,
        onScroll: handleScroll,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          messageList,
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "chatListBottom", ref: messagesEndRef })
        ] })
      }
    )
  ] });
}
styled("div")(({ theme }) => ({
  cursor: "row-resize",
  margin: "4px",
  hr: {
    border: `1px solid ${theme.palette.divider}`
  }
}));
styled(Stack)({
  flex: "1",
  overflow: "hidden"
});
function SocialFooter() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "center", spacing: 1, sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { href: "https://discord.gg/ZM6Eazpz5V", target: "_blank", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faDiscord, size: "xl" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { href: "https://github.com/Deepbluewarn/twitch-badge-collector-v2", target: "_blank", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faGithub, size: "xl" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { href: "mailto:tbcextension@gmail.com", target: "_blank", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faEnvelope, size: "xl" }) })
  ] });
}
function useCustomTheme(theme) {
  const baseTheme = createTheme({
    palette: {
      mode: theme === "on" ? "dark" : "light"
    },
    typography: {
      fontFamily: [
        "Pretendard Variable",
        "-apple-system",
        "BlinkMacSystemFont",
        "system-ui",
        "Roboto",
        "Helvetica Neue",
        "Segoe UI",
        "Apple SD Gothic Neo",
        "Noto Sans KR",
        "Malgun Gothic",
        "sans-serif"
      ].join(",")
    }
  });
  return {
    ...baseTheme,
    colors: theme === "on" ? {
      textColor_1: "#ececec",
      textColor_2: "#d3d3d3",
      textColorInverted: "#000000",
      bgColor_1: "#121212",
      bgColor_2: "#1e1e1e",
      bgColor_3: "#343434",
      remoteBgColor: "#18181b",
      filterIncludeTypeColor: lightGreen[500],
      filterExcludeTypeColor: red[500],
      filterSleepTypeColor: grey[400],
      highlightColor: "#ffc107",
      buttonColor: "#000000",
      buttonDisabledBgColor: "#fffafa",
      scrollbarBgColor: "#343434",
      modalBgColor: "#00000044",
      borderColor: grey[800]
    } : {
      textColor_1: "#000000",
      textColor_2: "#2e2e2e",
      textColorInverted: "#ececec",
      bgColor_1: "#ffffff",
      bgColor_2: "#f7f7f8",
      bgColor_3: "#e5e5e5",
      remoteBgColor: "#ffffff",
      filterIncludeTypeColor: lightGreen[500],
      filterExcludeTypeColor: red[500],
      filterSleepTypeColor: grey[400],
      highlightColor: "#ffc107",
      buttonColor: "#000000",
      buttonDisabledBgColor: "#fffafa",
      scrollbarBgColor: "#b3b3b3",
      modalBgColor: "#00000044",
      borderColor: grey[300]
    }
  };
}
function ChatSaverDialog(props) {
  const { t: t2 } = useTranslation();
  const { globalSetting } = useGlobalSettingContext();
  const [bgColor, setBgColor] = useState(useTheme().colors.remoteBgColor);
  const handleSaveDialogClose = () => props.setOpenSaveDialog(false);
  const chatContainerWrapperRef = useRef(null);
  const saveChatAsImage = useCallback(() => {
    if (chatContainerWrapperRef.current === null)
      return;
    const chatContainer = chatContainerWrapperRef.current.getElementsByClassName(
      "chat-list"
    )[0];
    if (!chatContainer)
      return;
    const date = /* @__PURE__ */ new Date();
    htmlToImage.toPng(chatContainer, {
      cacheBust: true,
      backgroundColor: bgColor
    }).then((dataUrl) => {
      var _a;
      const link = document.createElement("a");
      link.download = `${date.toLocaleString()}-${(_a = props.channel) == null ? void 0 : _a.value}.png`;
      link.href = dataUrl;
      link.click();
      handleSaveDialogClose();
    }).catch((err) => {
      console.log(err);
    });
  }, [props.channel, bgColor]);
  useEffect(() => {
    setBgColor(useCustomTheme(globalSetting.darkTheme).colors.remoteBgColor);
  }, [globalSetting]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Dialog,
    {
      open: props.openSaveDialog,
      onClose: handleSaveDialogClose,
      scroll: "paper",
      "aria-labelledby": "scroll-dialog-title",
      "aria-describedby": "scroll-dialog-description",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(DialogTitle, { id: "scroll-dialog-title", children: t2("setting.save_chat") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContent, { sx: { "padding-top": "16px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            ref: chatContainerWrapperRef,
            className: "chat-container-wrapper",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              ChatContainer,
              {
                onlySelected: true,
                messageList: props.chatList,
                type: "origin"
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(DialogActions, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSaveDialogClose, children: t2("common.cancel") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: saveChatAsImage, children: t2("common.save") })
        ] })
      ]
    }
  );
}
function ChatSaver(props) {
  const { addAlert } = useAlertContext();
  const { t: t2 } = useTranslation();
  const { channel: channel2 } = useChannelInfoContext();
  const [channelChatList, setChannelChatList] = React.useState();
  const userColorMapRef = React.useRef(/* @__PURE__ */ new Map());
  const [index2, setIndex] = React.useState(1);
  const [chatList, setChatList] = React.useState([]);
  const [openSaveDialog, setOpenSaveDialog] = React.useState(false);
  const handleSaveDialogOpen = () => setOpenSaveDialog(true);
  const saveButtonClicked = () => {
    const selected = chatList.some((c) => c.selected);
    if (selected) {
      handleSaveDialogOpen();
    } else {
      addAlert({ serverity: "warning", message: t2("alert.no_selected_chat") });
    }
  };
  React.useEffect(() => {
    document.title = `${t2("setting.save_chat")}- TBC`;
  }, []);
  React.useEffect(() => {
    setChannelChatList(props.channelChatListMap.get(props.selectedChannel));
    setIndex(1);
  }, [props.channelChatListMap, props.selectedChannel]);
  React.useEffect(() => {
    const channel22 = props.channelChatListMap.get(props.selectedChannel);
    if (!channel22)
      return;
    const chatLists = channel22.chatLists[index2 - 1];
    if (chatLists) {
      setChatList(chatLists.list);
    }
  }, [props.channelChatListMap, props.selectedChannel, index2]);
  const onChannelSelected = (event) => {
    props.setSelectedChannel(event.target.value);
  };
  const onSelectionChanged = (event) => {
    setIndex(event.target.value);
  };
  const channelMenuItems = Array.from(props.channelInfoList.values()).map((v) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: v.loginName, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChannelComp,
      {
        profileImgUrl: v.profileImgUrl,
        displayName: v.displayName
      }
    ) }, v.loginName);
  });
  const getChannelInfo = (channel22) => {
    const channelInfo = props.channelInfoList.get(channel22);
    return channelInfo ? channelInfo : {
      profileImgUrl: "",
      displayName: "",
      loginName: ""
    };
  };
  const onRefreshButtonClicked = () => {
    props.setChannelInfoList(/* @__PURE__ */ new Map());
    props.setChannelChatListMap(/* @__PURE__ */ new Map());
    setChannelChatList(void 0);
    props.setSelectedChannel("");
    setChatList([]);
    setIndex(1);
    props.requestChannelList();
  };
  const channelSelector = /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", gap: 2, alignItems: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl, { sx: { width: "100%" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, { children: t2("common.channel_select") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Select,
        {
          label: t2("common.channel_select"),
          value: props.selectedChannel,
          variant: "outlined",
          onChange: onChannelSelected,
          renderValue: (selected) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            ChannelComp,
            {
              profileImgUrl: getChannelInfo(selected).profileImgUrl,
              displayName: getChannelInfo(selected).displayName
            }
          ),
          children: channelMenuItems
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        size: "large",
        "aria-label": "account of current user",
        "aria-controls": "menu-appbar",
        "aria-haspopup": "true",
        color: "inherit",
        onClick: onRefreshButtonClicked,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(RefreshIcon, {})
      }
    )
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(UserColorContext.Provider, { value: userColorMapRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatSaverDialog, { chatList, channel: channel2, openSaveDialog, setOpenSaveDialog }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { spacing: 2, sx: { height: "100%" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Card,
        {
          sx: {
            padding: "16px",
            flex: "1",
            display: "flex",
            flexDirection: "column"
          },
          className: "card",
          variant: "outlined",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(CardHeader, { title: channelSelector }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CardContent,
              {
                sx: {
                  overflow: "auto",
                  flex: "1 1 auto",
                  height: "100px"
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Stack,
                  {
                    justifyContent: "center",
                    alignItems: "flex-start",
                    sx: { height: "100%" },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Container,
                      {
                        sx: {
                          width: "100%",
                          height: "100%",
                          marginLeft: "0",
                          marginRight: "0"
                        },
                        disableGutters: true,
                        className: "chat-container-wrapper",
                        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                          ChatContainer,
                          {
                            messageList: chatList,
                            setMessageList: setChatList,
                            type: "origin",
                            selectable: true
                          }
                        )
                      }
                    )
                  }
                )
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(CardActions, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Stack,
              {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: { width: "100%" },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl, { sx: { m: 1, minWidth: 122 }, size: "small", children: channelChatList && channelChatList.chatLists.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, { id: "select-chat-list", children: t2("common.chat_list") }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Select,
                      {
                        id: "select-chat-list",
                        label: t2("common.chat_list"),
                        value: index2,
                        onChange: onSelectionChanged,
                        variant: "outlined",
                        children: channelChatList.chatLists.map((cl, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: i + 1, children: `${i + 1} - ${t2(`common.${cl.chatListType}`)}` }, i + 1))
                      }
                    )
                  ] }) : null }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "row", spacing: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "contained", onClick: saveButtonClicked, children: t2("common.save") }) })
                ]
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SocialFooter, {})
    ] })
  ] });
}
function ChannelComp(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", alignItems: "center", spacing: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Avatar, { src: props.profileImgUrl, sx: { width: 34, height: 34 } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { variant: "subtitle2", children: props.displayName })
  ] });
}
const ChzzkAPIContext = createContext(void 0);
function useChzzkAPIContext() {
  const context = useContext(ChzzkAPIContext);
  if (typeof context === "undefined") {
    throw new Error("ChzzkAPIContext must be within ChzzkAPIProvider");
  }
  return context;
}
const AuthContext = createContext(void 0);
function useAuthContext() {
  const context = useContext(AuthContext);
  if (typeof context === "undefined") {
    throw new Error("AuthContext must be within AuthProvider");
  }
  return context;
}
const ArrayFilterContext = createContext(void 0);
function useArrayFilterContext() {
  const context = useContext(ArrayFilterContext);
  if (typeof context === "undefined") {
    throw new Error("ArrayFilterContext must be within ArrayFilterProvider");
  }
  return context;
}
const BadgeListChannelContext = createContext(void 0);
const BadgeChannelNameContext = createContext(void 0);
function useBadgeListChannelContext() {
  const context = useContext(BadgeListChannelContext);
  if (typeof context === "undefined") {
    throw new Error("BadgeListChannelContext must be within BadgeListChannelProvider");
  }
  return context;
}
function useBadgeChannelNameContext() {
  const context = useContext(BadgeChannelNameContext);
  if (typeof context === "undefined") {
    throw new Error("BadgeChannelNameContext must be within BadgeChannelNameProvider");
  }
  return context;
}
const ChannelContext = createContext(void 0);
function useChannelContext() {
  const context = useContext(ChannelContext);
  if (typeof context === "undefined") {
    throw new Error("ChannelContext must be within ChannelProvider");
  }
  return context;
}
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertContext,
  ArrayFilterContext,
  AuthContext,
  BadgeChannelNameContext,
  BadgeListChannelContext,
  ChannelContext,
  ChannelInfoContext,
  ChzzkAPIContext,
  GlobalSettingContext,
  TwitchAPIContext,
  UserColorContext,
  useAlertContext,
  useArrayFilterContext,
  useAuthContext,
  useBadgeChannelNameContext,
  useBadgeListChannelContext,
  useChannelContext,
  useChannelInfoContext,
  useChzzkAPIContext,
  useGlobalSettingContext,
  useTwitchAPIContext
}, Symbol.toStringTag, { value: "Module" }));
function chatInfoReducer(state, action) {
  const copyState = { ...state };
  switch (action.type) {
    case "globalBadges":
      copyState.globalBadges = action.value;
      return copyState;
    case "channelBadges":
      copyState.channelBadges = action.value;
      return copyState;
    case "emotesets":
      copyState.emotesets = action.value;
      return copyState;
    case "cheermotes":
      copyState.cheermotes = action.value;
      return copyState;
    default:
      throw new Error("Unhandled action");
  }
}
function useChannelInfo() {
  const twitchAPI2 = useTwitchAPIContext();
  const { addAlert } = useAlertContext();
  const [channelInfoObject, dispatchChannelInfo] = React.useReducer(chatInfoReducer, {
    globalBadges: /* @__PURE__ */ new Map(),
    channelBadges: /* @__PURE__ */ new Map(),
    emotesets: /* @__PURE__ */ new Map(),
    cheermotes: /* @__PURE__ */ new Map()
  });
  const [channelInfo, setChannelInfo] = React.useState();
  const [channel2, setChannel] = React.useState();
  const [userId, setUserId] = React.useState("");
  const [isChannelInfoObjSuccess, setIsChannelInfoObjSuccess] = React.useState(false);
  const { data: GlobalBadges, isSuccess: isGlobalBadgesSuccess } = useQuery(
    ["GlobalBadges"],
    () => twitchAPI2.fetchGlobalChatBadges()
  );
  const { data: ChannelChatBadges, isSuccess: isChannelChatBadgesSuccess } = useQuery(
    ["ChannelChatBadges", userId],
    () => twitchAPI2.fetchChannelChatBadges(userId),
    {
      enabled: userId !== ""
    }
  );
  const { data: Cheermotes, isSuccess: isCheermotesSuccess } = useQuery(
    ["Cheermotes", userId],
    () => twitchAPI2.fetchCheermotes(userId),
    {
      enabled: userId !== ""
    }
  );
  const { data: User } = useQuery(
    ["User", channel2],
    () => twitchAPI2.fetchUser(channel2.type, channel2.value),
    {
      enabled: typeof channel2 !== "undefined" && channel2.value !== ""
    }
  );
  React.useEffect(() => {
    if (!GlobalBadges)
      return;
    dispatchChannelInfo({ type: "globalBadges", value: GlobalBadges });
  }, [GlobalBadges]);
  React.useEffect(() => {
    if (!ChannelChatBadges)
      return;
    dispatchChannelInfo({ type: "channelBadges", value: ChannelChatBadges });
  }, [ChannelChatBadges]);
  React.useEffect(() => {
    if (!Cheermotes)
      return;
    dispatchChannelInfo({ type: "cheermotes", value: Cheermotes });
  }, [Cheermotes]);
  React.useEffect(
    () => {
      setIsChannelInfoObjSuccess(
        isGlobalBadgesSuccess && isChannelChatBadgesSuccess && isCheermotesSuccess
      );
    },
    [
      isGlobalBadgesSuccess,
      isChannelChatBadgesSuccess,
      isCheermotesSuccess
    ]
  );
  React.useEffect(() => {
    if (typeof User === "undefined")
      return;
    const data = User.data[0];
    if (typeof data === "undefined") {
      addAlert({ serverity: "warning", message: t("alert.channel_not_found") });
      return;
    }
    const id = data.id;
    setChannelInfo({
      profileImgUrl: data.profile_image_url,
      displayName: data.display_name,
      loginName: data.login
    });
    setUserId(id);
  }, [User]);
  return { channelInfoObject, dispatchChannelInfo, channelInfo, isChannelInfoObjSuccess, channel: channel2, setChannel, User };
}
function ChatSaverWeb() {
  const { channelInfoObject, dispatchChannelInfo, channel: channel2, setChannel, User } = useChannelInfo();
  const [channelChatListMap, setChannelChatListMap] = React.useState(/* @__PURE__ */ new Map());
  const [channelInfoList, setChannelInfoList] = React.useState(/* @__PURE__ */ new Map());
  const [selectedChannel, setSelectedChannel] = React.useState("");
  const postRequestChannelMessage = () => {
    const ChannelInfoBroadcastChannel = new BroadcastChannel("ChannelInfoList");
    ChannelInfoBroadcastChannel.postMessage({
      messageType: "CHATSAVER_REQUEST_CHANNEL_INFO"
    });
  };
  useEffect(() => {
    postRequestChannelMessage();
  }, []);
  React.useEffect(() => {
    postRequestChannelMessage();
    const ChatListBroadcastChannel = new BroadcastChannel("ChatList");
    const ChannelInfoBroadcastChannel = new BroadcastChannel("ChannelInfoList");
    ChannelInfoBroadcastChannel.onmessage = (msg) => {
      if (typeof msg.channelInfo === "undefined")
        return;
      if (msg.messageType === "CHATSAVER_RESPONSE_CHANNEL_INFO") {
        setChannelInfoList((list) => {
          const cloneList = new Map(list);
          const channelInfo = msg.channelInfo;
          if (!channelInfo)
            return list;
          cloneList.set(channelInfo.loginName, channelInfo);
          return cloneList;
        });
      }
    };
    ChatListBroadcastChannel.onmessage = (msg) => {
      if (msg.messageType === "CHATSAVER_RESPONSE_CHAT_LIST") {
        if (msg.channel && msg.chatList) {
          const channelInfo = msg.channelInfo;
          if (typeof channelInfo === "undefined")
            return;
          const channelLogin = channelInfo.loginName;
          const channelChatList = msg.chatList;
          const chatListType = msg.chatListType;
          const chatListId = msg.chatListId;
          setChannelChatListMap((channels) => {
            const copyChannels = new Map(channels);
            if (!chatListId)
              return channels;
            if (copyChannels.has(channelLogin)) {
              const list = copyChannels.get(channelLogin);
              if (!list)
                return channels;
              const hasChatId = list.chatLists.some((chat2) => {
                return chat2.listId === chatListId;
              });
              if (!hasChatId) {
                list.chatLists.push({
                  list: channelChatList,
                  listId: chatListId,
                  chatListType
                });
              }
              copyChannels.set(channelLogin, list);
            } else {
              copyChannels.set(channelLogin, {
                chatLists: [{
                  list: channelChatList,
                  listId: chatListId,
                  chatListType
                }],
                channelInfo
              });
            }
            return copyChannels;
          });
        }
      }
    };
  }, []);
  React.useEffect(() => {
    const ChatListBroadcastChannel = new BroadcastChannel("ChatList");
    ChatListBroadcastChannel.postMessage({
      messageType: "CHATSAVER_REQUEST_CHAT_LIST",
      channel: { type: "login", value: selectedChannel }
    });
    setChannel({ type: "login", value: selectedChannel });
  }, [selectedChannel]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ChannelInfoContext.Provider,
    {
      value: { channelInfoObject, dispatchChannelInfo, channel: channel2, setChannel, User },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ChatSaver,
        {
          channelChatListMap,
          setChannelChatListMap,
          channelInfoList,
          setChannelInfoList,
          selectedChannel,
          setSelectedChannel,
          requestChannelList: postRequestChannelMessage
        }
      )
    }
  );
}
const CategoryArr = ["badge_uuid", "login_name", "keyword"];
const TypeArr$1 = ["include", "exclude", "sleep"];
const ArrayFilterCategoryArr = ["badge", "name", "keyword"];
const filter$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ArrayFilterCategoryArr,
  CategoryArr,
  TypeArr: TypeArr$1
}, Symbol.toStringTag, { value: "Module" }));
function onArrayFilterTypeChipClick(params, setRows) {
  if (params.field === "filterType" && typeof params.value !== "undefined") {
    const newType = rotateFilterType(params.value);
    setRows((rows) => {
      return rows.map(({ filterType, ...rows2 }) => ({
        ...rows2,
        filterType: rows2.id === params.id ? newType : filterType
      }));
    });
  }
}
function onBadgeTypeChipClick(params, setRows) {
  if (params.field === "filterType" && typeof params.value !== "undefined") {
    const newType = rotateFilterType(params.value);
    setRows((rows) => {
      return rows.map(({ filterType, ...rows2 }) => ({
        ...rows2,
        filterType: rows2.id === params.id ? newType : filterType
      }));
    });
  }
}
function rotateFilterType(current) {
  const current_index = TypeArr$1.indexOf(current);
  if (current_index === -1)
    return TypeArr$1[0];
  const nextIndex = (current_index + 1) % TypeArr$1.length;
  return TypeArr$1[nextIndex];
}
function chipColor(type) {
  return type === "include" ? "success" : type === "exclude" ? "error" : "default";
}
const onTypeCellClick = (params, event) => {
  event.defaultMuiPrevented = params.field === "filterType";
};
function CustomDataGrid(props) {
  const { i18n: i18n2 } = useTranslation();
  const locale = i18n2.language === "ko" ? koKR : enUS;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { height: "27rem" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    DataGrid,
    {
      componentsProps: props.componentsProps,
      localeText: locale.components.MuiDataGrid.defaultProps.localeText,
      sx: { "height": "27rem" },
      getRowHeight: () => "auto",
      onCellClick: onTypeCellClick,
      initialState: {
        pagination: {
          paginationModel: { page: 0, pageSize: 6 }
        }
      },
      pageSizeOptions: [6],
      checkboxSelection: true,
      ...props
    }
  ) });
}
const RelaxedChip = React.forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, { ...props, ref, sx: { margin: "5px" } });
});
function CustomToolbar$1(props) {
  const { globalSetting } = useGlobalSettingContext();
  const customToolbarContainer = globalSetting.platform === "twitch" ? /* @__PURE__ */ jsxRuntimeExports.jsx(CustomToolbarContainer, {}) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BadgeListChannelContext.Provider, { value: {
    badgeListChannel: props.badgeListChannel,
    setBadgeListChannel: props.setBadgeListChannel
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BadgeChannelNameContext.Provider, { value: {
    badgeChannelName: props.badgeChannelName,
    setBadgeChannelName: props.setBadgeChannelName
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(GridToolbarContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridToolbarFilterButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddBadgeFilterButton,
      {
        badgesRow: props.badgesRow,
        setAfInputRow: props.setAfInputRow,
        selectionModel: props.selectionModel,
        setSelectionModel: props.setSelectionModel,
        setShowAddButton: props.setShowAddButton,
        showAddButton: props.showAddButton
      }
    ),
    customToolbarContainer
  ] }) }) });
}
function BadgeList(props) {
  const { globalSetting } = useGlobalSettingContext();
  const [advancedFilter, setAdvancedFilter] = useState(globalSetting.advancedFilter === "on");
  const [badgesRow, setBadgesRows] = React.useState([]);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [showAddButton, setShowAddButton] = React.useState(false);
  const [badgeListChannel, setBadgeListChannel] = React.useState("global");
  const [badgeChannelName, setBadgeChannelName] = React.useState("");
  const [userId, setUserId] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const { t: t2 } = useTranslation();
  const twitchAPI2 = useTwitchAPIContext();
  const chzzkAPI2 = useChzzkAPIContext();
  const columns = [
    {
      field: "badgeImage",
      headerName: t2("common.badge"),
      flex: 0.1,
      renderCell: (params) => {
        var _a, _b, _c, _d;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            style: { width: "18px", height: "18px" },
            src: (_a = params.value) == null ? void 0 : _a.badge_img_url_1x,
            srcSet: `${(_b = params.value) == null ? void 0 : _b.badge_img_url_1x} 1x, 
                            ${(_c = params.value) == null ? void 0 : _c.badge_img_url_2x} 2x, 
                            ${(_d = params.value) == null ? void 0 : _d.badge_img_url_4x} 4x`
          }
        );
      }
    },
    { field: "channel", headerName: t2("common.channel"), flex: 0.2 },
    { field: "note", headerName: t2("common.note"), flex: 0.6 },
    { field: "badgeName", headerName: t2("common.badge_name"), flex: 0.6 },
    {
      field: "filterType",
      headerName: t2("common.condition"),
      flex: 0.2,
      renderCell: (params) => {
        if (!params.value)
          return null;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          RelaxedChip,
          {
            label: t2(`filter.category.${params.value}`),
            color: chipColor(params.value),
            onClick: () => onBadgeTypeChipClick(params, setBadgesRows)
          }
        );
      }
    }
  ];
  const { data: User } = useQuery(
    ["User", badgeChannelName, globalSetting.platform],
    () => twitchAPI2.fetchUser("login", badgeChannelName),
    {
      enabled: badgeChannelName !== "" && globalSetting.platform === "twitch"
    }
  );
  const { data: GlobalBadges, isSuccess: isGBSuccess, fetchStatus: GBFetchStatus } = useQuery(
    ["GlobalBadges", badgeListChannel, globalSetting.platform],
    () => twitchAPI2.fetchGlobalChatBadges(),
    {
      enabled: badgeListChannel === "global" && globalSetting.platform === "twitch"
    }
  );
  const { data: ChannelChatBadges, isSuccess: isCBSuccess, fetchStatus: CBFetchStatus } = useQuery(
    ["ChannelChatBadges", badgeListChannel, userId, globalSetting.platform],
    () => twitchAPI2.fetchChannelChatBadges(userId),
    {
      enabled: badgeListChannel === "channel" && userId !== "" && globalSetting.platform === "twitch"
    }
  );
  const { data: ChzzkBadges, isSuccess: isChzzkSuccess, fetchStatus: ChzzkFetchStatus } = useQuery(
    ["ChzzkBadges", globalSetting.platform],
    async () => chzzkAPI2.fetchBadges(),
    {
      enabled: globalSetting.platform === "chzzk"
    }
  );
  const updateFilterInput = (id) => {
    if (typeof id === "undefined")
      return;
    const badge = badgesRow.find((badge2) => badge2.id === id.toString());
    if (!badge)
      return;
    const badgeUUID = globalSetting.platform === "twitch" ? badgeUuidFromURL(badge.badgeImage.badge_img_url_1x) : badge.badgeImage.badge_img_url_1x;
    props.setFilterInput({
      category: "badge",
      id: nanoid(),
      type: badge.filterType,
      value: badgeUUID,
      badgeName: `${badge.channel}: ${badge.badgeName}`
    });
  };
  React.useEffect(() => {
    if (!GlobalBadges)
      return;
    const badgesArray = badgesToArray(GlobalBadges);
    const badgesRow2 = badgesArray.map((badge) => {
      return {
        id: `${badge.image_url_1x}-${badge.description}-${badge.key}`,
        badgeImage: {
          badge_img_url_1x: badge.image_url_1x,
          badge_img_url_2x: badge.image_url_2x,
          badge_img_url_4x: badge.image_url_4x
        },
        channel: "Global",
        note: badge.description,
        badgeName: badge.title,
        filterType: "include"
      };
    });
    setLoading(false);
    setBadgesRows(badgesRow2);
  }, [GlobalBadges]);
  React.useEffect(() => {
    if (!User || User.data.length === 0)
      return;
    setUserId(User.data[0].id);
  }, [User]);
  React.useEffect(() => {
    if (!ChannelChatBadges || (!User || User.data.length === 0))
      return;
    const badgesArray = badgesToArray(ChannelChatBadges);
    const channelName = User.data[0].display_name;
    const badgesRow2 = badgesArray.map((badge) => {
      return {
        id: `${badge.image_url_1x}-${badge.description}-${badge.key}`,
        badgeImage: {
          badge_img_url_1x: badge.image_url_1x,
          badge_img_url_2x: badge.image_url_2x,
          badge_img_url_4x: badge.image_url_4x
        },
        channel: channelName,
        note: badge.description,
        badgeName: badge.title,
        filterType: "include"
      };
    });
    setBadgesRows(badgesRow2);
  }, [ChannelChatBadges, User]);
  React.useEffect(() => {
    if (GBFetchStatus === "fetching" || CBFetchStatus === "fetching" || ChzzkFetchStatus === "fetching") {
      setLoading(true);
    } else if (GBFetchStatus === "idle" || CBFetchStatus === "idle" || ChzzkFetchStatus === "idle") {
      setLoading(false);
    }
  }, [GBFetchStatus, CBFetchStatus, ChzzkFetchStatus]);
  useEffect(() => {
    if (!ChzzkBadges)
      return;
    const badgesRow2 = ChzzkBadges.map((badge) => {
      return {
        id: badge.id,
        badgeImage: {
          badge_img_url_1x: badge.image,
          badge_img_url_2x: badge.image,
          badge_img_url_4x: badge.image
        },
        channel: "Global",
        note: badge.name,
        badgeName: badge.name,
        filterType: "include"
      };
    });
    setBadgesRows(badgesRow2);
  }, [ChzzkBadges]);
  useEffect(() => {
    setAdvancedFilter(globalSetting.advancedFilter === "on");
  }, [globalSetting]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CustomDataGrid,
    {
      rows: badgesRow,
      columns,
      components: { Toolbar: CustomToolbar$1 },
      loading,
      componentsProps: {
        toolbar: {
          badgesRow,
          setAfInputRow: props.setAfInputRow,
          selectionModel,
          setSelectionModel,
          showAddButton,
          setShowAddButton,
          badgeListChannel,
          setBadgeListChannel,
          badgeChannelName,
          setBadgeChannelName,
          platform: globalSetting.platform
        }
      },
      onRowSelectionModelChange: (ids) => {
        setShowAddButton(advancedFilter && ids.length > 0);
        setSelectionModel(ids);
        updateFilterInput(ids[0]);
      },
      rowSelectionModel: selectionModel,
      checkboxSelection: advancedFilter
    }
  );
}
function badgesToArray(badges) {
  const res = [];
  for (let [key, version] of badges) {
    let badgeInfo = {
      ...version,
      set_id: key,
      // The key of the map is used as the set_id
      type: "",
      // type 정보가 없으므로 빈 문자열로 설정
      key: "",
      // key 정보가 없으므로 빈 문자열로 설정
      click_action: "",
      // click_action 정보가 없으므로 빈 문자열로 설정
      last_updated: null
      // last_updated 정보가 없으므로 null로 설정
    };
    res.push(badgeInfo);
  }
  return res;
}
function AddSelectedBadges(badgesRow, setAfInputRow, selectionModel, setSelectionModel, setShowAddButton) {
  const { globalSetting } = useGlobalSettingContext();
  setAfInputRow((list) => {
    const newList = badgesRow.map((badge) => {
      const badgeUUID = globalSetting.platform === "twitch" ? badgeUuidFromURL(badge.badgeImage.badge_img_url_1x) : badge.badgeImage.badge_img_url_1x;
      if (!selectionModel.includes(badge.id))
        return;
      return {
        category: "badge",
        id: nanoid(),
        type: badge.filterType,
        value: badgeUUID,
        badgeName: `${badge.channel}: ${badge.badgeName}`
      };
    }).filter((r) => typeof r !== "undefined");
    return [...list, ...newList];
  });
  setShowAddButton(false);
  setSelectionModel([]);
}
function ChannelInput() {
  const { badgeListChannel, setBadgeListChannel } = useBadgeListChannelContext();
  const { badgeChannelName, setBadgeChannelName } = useBadgeChannelNameContext();
  const channelName = React.useRef("");
  const { t: t2 } = useTranslation();
  const onBCButtonClicked = () => {
    setBadgeListChannel(badgeListChannel === "global" ? "channel" : "global");
  };
  const BadgeChannelButton = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { disabled: badgeListChannel === "global", onClick: onBCButtonClicked, children: t2("common.global") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { disabled: badgeListChannel === "channel", onClick: onBCButtonClicked, children: t2("common.channel") })
    ] });
  };
  const onSearchButtonClicked = () => {
    const noWhiteSpace = channelName.current.replaceAll(" ", "");
    setBadgeChannelName(noWhiteSpace);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", sx: { justifyContent: "flex-end" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BadgeChannelButton, {}),
    badgeListChannel === "channel" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextField,
        {
          id: "outlined-basic",
          label: t2("common.channel_name"),
          variant: "outlined",
          size: "small",
          onChange: (e) => {
            channelName.current = e.target.value;
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: onSearchButtonClicked, children: t2("common.search") })
    ] }) : null
  ] });
}
function CustomToolbarContainer() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: {
    flex: "1",
    margin: "4px"
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChannelInput, {}) });
}
function AddBadgeFilterButton(props) {
  if (!props.showAddButton)
    return null;
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Stack,
    {
      direction: "row",
      onClick: () => {
        AddSelectedBadges(
          props.badgesRow,
          props.setAfInputRow,
          props.selectionModel,
          props.setSelectionModel,
          props.setShowAddButton
        );
      },
      sx: {
        alignItems: "center",
        padding: "4px",
        cursor: "pointer"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "material-icons-round", children: "add" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t2("common.add_selected") })
      ]
    }
  );
}
function ArrayFilterTypeSelector(props) {
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl, { sx: { minWidth: 120 }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, { id: "arrayFilterType", children: t2("common.condition") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Select,
      {
        labelId: "arrayFilterType",
        label: t2("common.condition"),
        size: "small",
        ...props,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: "include", children: t2("filter.category.include") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: "exclude", children: t2("filter.category.exclude") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: "sleep", children: t2("filter.category.sleep") })
        ]
      }
    )
  ] });
}
function FilterCategorySelector(props) {
  const { t: t2 } = useTranslation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl, { sx: { minWidth: 120 }, size: "small", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, { id: "filter-category-label", children: t2("common.category") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Select,
      {
        labelId: "filter-category-label",
        className: "filter-category",
        label: t2("common.category"),
        ...props,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: "name", children: t2("common.nickname") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: "keyword", children: t2("common.keyword") })
        ]
      }
    )
  ] });
}
function ArrayFilterCategorySelector(props) {
  const { t: t2 } = useTranslation();
  const { nameFilterAvail, ...rest } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl, { sx: { minWidth: 120 }, size: "small", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, { id: "filter-category-label", children: t2("common.category") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Select,
      {
        labelId: "filter-category-label",
        className: "filter-category",
        label: t2("common.category"),
        ...rest,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { disabled: props.nameFilterAvail, value: "name", children: t2("common.nickname") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: "keyword", children: t2("common.keyword") })
        ]
      }
    )
  ] });
}
function CustomTextField(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextField,
    {
      ...props,
      id: "outlined-basic",
      variant: "outlined",
      size: "small",
      sx: { flex: "1" }
    }
  );
}
function FilterInputFormList(props) {
  const matches = useMediaQuery("(min-width:600px)");
  const { globalSetting } = useGlobalSettingContext();
  const { addArrayFilter } = useArrayFilterContext();
  const [arrayFilterType, setArrayFilterType] = React.useState("include");
  const [arrayFilterNote, setArrayFilterNote] = useState("");
  const [nameFilterAvail, setNameFilterAvail] = React.useState(false);
  const { t: t2 } = useTranslation();
  const addFilterInputForm = () => {
    props.setAfInputRow((list) => {
      return [...list, {
        category: nameFilterAvail ? "keyword" : "name",
        id: nanoid(),
        type: "include",
        value: ""
      }];
    });
  };
  const onArrayFilterTypeChanged = (event) => {
    setArrayFilterType(event.target.value);
  };
  const onArrayFilterNoteChanged = (event) => {
    setArrayFilterNote(event.target.value);
  };
  const addFilter = useCallback(() => {
    const added = addArrayFilter([{
      filterType: arrayFilterType,
      id: nanoid(),
      filterNote: arrayFilterNote,
      filters: [...props.filterInputListRef.current],
      platform: globalSetting.platform
    }]);
    if (added) {
      resetArrayFilterInputList();
      setArrayFilterNote("");
    }
  }, [arrayFilterType, arrayFilterNote, globalSetting.platform]);
  const resetArrayFilterInputList = () => {
    props.setAfInputRow([]);
  };
  React.useEffect(() => {
    const rows = props.afInputRow;
    props.filterInputListRef.current = rows;
    setNameFilterAvail(rows.some((row) => row.category === "name"));
  }, [props.afInputRow]);
  useEffect(() => {
    resetArrayFilterInputList();
  }, [globalSetting.platform]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { variant: "outlined", sx: { overflow: "visible" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardContent, { sx: { display: "flex", minHeight: "22rem" }, children: props.afInputRow.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { spacing: 2, sx: { width: "100%" }, children: props.afInputRow.map((input) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        AdvancedFilterInputForm,
        {
          value: input,
          setInputList: props.setAfInputRow,
          afInputListRef: props.filterInputListRef,
          nameFilterAvail
        },
        input.id
      );
    }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { justifyContent: "center", alignItems: "center", sx: { "width": "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { color: "textSecondary", variant: "subtitle1", gutterBottom: true, children: t2("common.add_filter_elements") }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardActions, { sx: { padding: "16px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Stack,
      {
        direction: "row",
        justifyContent: "space-between",
        sx: { width: "100%" },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: addFilterInputForm, children: t2("common.add_filter_element") }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: matches ? "row" : "column", gap: 1, flex: "0.7", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CustomTextField,
              {
                value: arrayFilterNote,
                label: t2("필터 설명을 추가하세요"),
                onChange: onArrayFilterNoteChanged
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              ArrayFilterTypeSelector,
              {
                labelId: "arrayFilterType",
                value: arrayFilterType,
                onChange: onArrayFilterTypeChanged
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button,
              {
                disabled: props.afInputRow.length === 0,
                onClick: addFilter,
                variant: "contained",
                children: t2("common.add_filter")
              }
            )
          ] })
        ]
      }
    ) })
  ] });
}
function AdvancedFilterInputForm(props) {
  const { globalSetting } = useGlobalSettingContext();
  const { t: t2 } = useTranslation();
  const inputChanged = (event) => {
    const newValue = event.target.value;
    const inputRef = props.afInputListRef.current;
    const newInputRef = inputRef.map((l) => {
      if (l.id === props.value.id) {
        if (l.category === "badge") {
          l.badgeName = newValue;
        } else {
          l.value = newValue;
        }
      }
      return l;
    });
    props.afInputListRef.current = newInputRef;
  };
  const selectorChanged = (event, selectorType) => {
    const newValue = event.target.value;
    props.setInputList((list) => {
      return list.map((l) => {
        if (l.id === props.value.id) {
          if (selectorType === "category") {
            l.category = newValue;
          } else if (selectorType === "type") {
            l.type = newValue;
          }
        }
        return l;
      });
    });
  };
  const removeList = (event, id) => {
    props.setInputList((list) => list.filter((l) => l.id !== id));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", spacing: 1, children: [
    props.value.category === "badge" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Paper,
        {
          variant: "outlined",
          sx: {
            minWidth: 120,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          children: globalSetting.platform === "twitch" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: `https://static-cdn.jtvnw.net/badges/v1/${props.value.value}/1`,
              srcSet: `https://static-cdn.jtvnw.net/badges/v1/${props.value.value}/1 1x, 
                            https://static-cdn.jtvnw.net/badges/v1/${props.value.value}/2 2x, 
                            https://static-cdn.jtvnw.net/badges/v1/${props.value.value}/3 4x`
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              style: { width: "18px", height: "18px" },
              src: props.value.value
            }
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomTextField,
        {
          label: t2("common.badge_name"),
          defaultValue: props.value.badgeName,
          onChange: inputChanged
        }
      )
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrayFilterCategorySelector,
        {
          value: props.value.category,
          onChange: (e) => selectorChanged(e, "category"),
          nameFilterAvail: props.nameFilterAvail
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomTextField,
        {
          label: t2("common.value"),
          defaultValue: props.value.value,
          onChange: inputChanged
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ArrayFilterTypeSelector,
      {
        labelId: "filter-type-label",
        value: props.value.type,
        onChange: (e) => selectorChanged(e, "type")
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: (e) => removeList(e, props.value.id), children: t2("common.remove") })
  ] });
}
function FilterInputForm(props) {
  const { t: t2 } = useTranslation();
  const matches = useMediaQuery("(min-width:600px)");
  const { globalSetting } = useGlobalSettingContext();
  const { addArrayFilter } = useArrayFilterContext();
  const [arrayFilterNote, setArrayFilterNote] = useState("");
  const inputValue = useRef(null);
  const onArrayFilterNoteChanged = (event) => {
    setArrayFilterNote(event.target.value);
  };
  const addFilter = useCallback(() => {
    if (typeof props.filterInput === "undefined")
      return;
    if (inputValue.current === null)
      return;
    const inputRef = inputValue.current;
    const value = inputRef == null ? void 0 : inputRef.value;
    if (props.filterInput.category === "badge") {
      props.filterInput.badgeName = value;
    } else {
      props.filterInput.value = value;
    }
    const filterType = props.filterInput.type;
    props.filterInput.type = "include";
    const added = addArrayFilter([{
      filterType,
      id: nanoid(),
      filterNote: arrayFilterNote,
      filters: [props.filterInput],
      platform: globalSetting.platform
    }]);
    if (added) {
      setArrayFilterNote("");
      props.setFilterInput(getDefaultArrayFilter());
      inputRef.value = "";
    }
  }, [props.filterInput, arrayFilterNote]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { variant: "outlined", sx: { overflow: "visible" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardContent, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      BasicFilterInputForm,
      {
        filterInput: props.filterInput,
        setFilterInput: props.setFilterInput,
        inputValue
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardActions, { sx: { padding: "16px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Stack,
      {
        direction: "row",
        justifyContent: "space-between",
        sx: { width: "100%" },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: matches ? "row" : "column", gap: 1, sx: { width: "100%" }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CustomTextField,
            {
              value: arrayFilterNote,
              label: t2("필터 설명을 추가하세요"),
              onChange: onArrayFilterNoteChanged
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              onClick: addFilter,
              variant: "contained",
              children: t2("common.add_filter")
            }
          )
        ] })
      }
    ) })
  ] });
}
function BasicFilterInputForm(props) {
  const { globalSetting } = useGlobalSettingContext();
  const { t: t2 } = useTranslation();
  const selectorChanged = (event, selectorType) => {
    const newValue = event.target.value;
    props.setFilterInput((l) => {
      const newL = { ...l };
      if (selectorType === "category") {
        newL.category = newValue;
      } else if (selectorType === "type") {
        newL.type = newValue;
      }
      return newL;
    });
  };
  const resetFilterInput = useCallback(() => {
    props.setFilterInput(getDefaultArrayFilter());
    const inputRef = props.inputValue.current;
    if (inputRef !== null) {
      inputRef.value = "";
    }
  }, []);
  useEffect(() => {
    if (props.filterInput.category === "badge") {
      props.inputValue.current.value = props.filterInput.badgeName;
    }
  }, [props.filterInput]);
  useEffect(() => {
    resetFilterInput();
  }, [globalSetting.platform]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", spacing: 1, children: [
    props.filterInput.category === "badge" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Paper,
        {
          variant: "outlined",
          sx: {
            minWidth: 120,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          children: globalSetting.platform === "twitch" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              style: { width: "18px", height: "18px" },
              src: `https://static-cdn.jtvnw.net/badges/v1/${props.filterInput.value}/1`,
              srcSet: `https://static-cdn.jtvnw.net/badges/v1/${props.filterInput.value}/1 1x, 
                            https://static-cdn.jtvnw.net/badges/v1/${props.filterInput.value}/2 2x, 
                            https://static-cdn.jtvnw.net/badges/v1/${props.filterInput.value}/3 4x`
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              style: { width: "18px", height: "18px" },
              src: props.filterInput.value
            }
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomTextField,
        {
          label: t2("common.badge_name"),
          defaultValue: props.filterInput.badgeName,
          inputRef: props.inputValue
        }
      )
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FilterCategorySelector,
        {
          value: props.filterInput.category,
          onChange: (e) => selectorChanged(e, "category")
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomTextField,
        {
          label: t2("common.value"),
          defaultValue: props.filterInput.value,
          inputRef: props.inputValue
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ArrayFilterTypeSelector,
      {
        labelId: "filter-type-label",
        value: props.filterInput.type,
        onChange: (e) => selectorChanged(e, "type")
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "contained", onClick: resetFilterInput, children: "초기화" })
  ] });
}
const CustomToolbarItemStyle = styled(Stack)({
  alignItems: "center",
  gap: "4px",
  cursor: "pointer",
  userSelect: "none",
  padding: "4px",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#00000022"
  }
});
function ImportFilter() {
  const { globalSetting } = useGlobalSettingContext();
  const { arrayFilter, setArrayFilter, addArrayFilter } = useArrayFilterContext();
  const { t: t2 } = useTranslation();
  const { addAlert } = useAlertContext();
  const inputRef = useRef(null);
  const handleChange = useCallback((event) => {
    const fileReader = new FileReader();
    if (!event.target.files)
      return;
    fileReader.readAsText(event.target.files[0], "UTF-8");
    fileReader.onloadend = (e) => {
      if (!e.target)
        return;
      let filterJson = JSON.parse(e.target.result);
      filterJson = filterJson.map((filter2) => {
        if (!filter2.platform) {
          filter2.platform = "twitch";
        }
        return filter2;
      });
      const platformFilter = filterJson.filter((filter2) => filter2.platform === globalSetting.platform);
      const preservedFilter = arrayFilter.filter((filter2) => filter2.platform !== globalSetting.platform);
      if (platformFilter.length === 0) {
        addAlert({
          serverity: "info",
          message: "추가 가능한 플랫폼 필터가 없습니다."
        });
        return;
      }
      setArrayFilter([]);
      addArrayFilter([...preservedFilter, ...platformFilter]);
      if (inputRef.current)
        inputRef.current.value = "";
    };
  }, [arrayFilter, globalSetting.platform]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "upload-filter", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CustomToolbarItemStyle, { direction: "row", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "material-icons-round", children: "file_upload" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t2("common.filter_import") })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { ref: inputRef, type: "file", accept: ".tbc", className: "hidden", id: "upload-filter", onChange: handleChange })
  ] });
}
function ExportFilter() {
  const { globalSetting } = useGlobalSettingContext();
  const { arrayFilter } = useArrayFilterContext();
  const { t: t2 } = useTranslation();
  const today = /* @__PURE__ */ new Date();
  const year = today.getFullYear();
  const month = ("0" + (today.getMonth() + 1)).slice(-2);
  const day = ("0" + today.getDate()).slice(-2);
  const dateString = year + "-" + month + "-" + day;
  const clickHandler = useCallback(() => {
    const platform = globalSetting.platform;
    const platformFilter = arrayFilter.filter((filter2) => filter2.platform === platform);
    downloadFile(JSON.stringify(platformFilter), `${dateString}_${platform}_filter_backup.tbc`, "text/json");
  }, [arrayFilter, globalSetting.platform]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CustomToolbarItemStyle, { direction: "row", onClick: clickHandler, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "material-icons-round", children: "file_download" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t2("common.filter_export") })
  ] });
}
const downloadFile = (data, fileName, fileType) => {
  const blob = new Blob([data], { type: fileType });
  const a = document.createElement("a");
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true
  });
  a.dispatchEvent(clickEvt);
  a.remove();
};
const ChipListStyle = styled(Stack)({
  display: "flex",
  flexWrap: "wrap",
  gap: "4px",
  width: "100%",
  overflow: "auto",
  lineHeight: "1.5",
  ".chip-label-filterBadgeImage": {
    display: "inline-block",
    verticalAlign: "middle"
  },
  ".MuiChip-outlined": {
    maxWidth: "10rem"
  }
});
function ArrayFilterList() {
  const { globalSetting } = useGlobalSettingContext();
  const { arrayFilter, setArrayFilter } = useArrayFilterContext();
  const [platformArrayFilter, setPlatformArrayFilter] = useState(arrayFilter);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [showDeleteButton, setShowDeleteButton] = React.useState(false);
  const { t: t2 } = useTranslation();
  const getColumns = useCallback(() => {
    return [
      {
        field: "filters",
        headerName: t2("common.filter"),
        flex: 0.6,
        renderCell: (params) => {
          if (!params.value)
            return null;
          if (platformArrayFilter.length > 0 && platformArrayFilter[0].platform !== globalSetting.platform)
            return null;
          const chips = params.value.map((af) => {
            let title = `${t2(`filter.type.${af.category || ""}`)}: ${af.value}`;
            let badgeAvatar;
            if (af.category === "badge") {
              const badgeUUID = af.value;
              title = af.badgeName || "";
              badgeAvatar = globalSetting.platform === "twitch" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                Avatar,
                {
                  alt: af.badgeName,
                  src: `https://static-cdn.jtvnw.net/badges/v1/${badgeUUID}/1`,
                  srcSet: `https://static-cdn.jtvnw.net/badges/v1/${badgeUUID}/1 1x,
                                    https://static-cdn.jtvnw.net/badges/v1/${badgeUUID}/2 2x,
                                    https://static-cdn.jtvnw.net/badges/v1/${badgeUUID}/3 4x`
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                Avatar,
                {
                  alt: af.badgeName,
                  src: badgeUUID
                }
              );
            }
            return /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              RelaxedChip,
              {
                label: title,
                avatar: badgeAvatar,
                color: chipColor(af.type)
              }
            ) }, `${title}-${af.id}`);
          });
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ChipListStyle, { direction: "row", children: chips });
        }
      },
      {
        field: "filterNote",
        headerName: "비고",
        flex: 0.2,
        renderCell: (params) => {
          if (!params.value)
            return null;
          return /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: params.value, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            RelaxedChip,
            {
              label: params.value,
              color: "secondary"
            }
          ) }, params.value);
        }
      },
      {
        field: "filterType",
        headerName: t2("common.condition"),
        flex: 0.2,
        renderCell: (params) => {
          if (!params.value)
            return null;
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            RelaxedChip,
            {
              label: t2(`filter.category.${params.value}`),
              color: chipColor(params.value),
              onClick: () => onArrayFilterTypeChipClick(params, setArrayFilter)
            }
          );
        }
      }
    ];
  }, [globalSetting.platform, platformArrayFilter]);
  useEffect(() => {
    localStorage.setItem("tbc-filter", JSON.stringify(arrayFilter));
  }, [arrayFilter]);
  useEffect(() => {
    setPlatformArrayFilter(arrayFilter.filter((af) => af.platform === globalSetting.platform));
  }, [arrayFilter, globalSetting.platform]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CustomDataGrid,
    {
      rows: platformArrayFilter,
      columns: getColumns(),
      components: { Toolbar: CustomToolbar },
      componentsProps: {
        toolbar: {
          selectionModel,
          showDeleteButton
        }
      },
      onRowSelectionModelChange: (ids) => {
        setShowDeleteButton(ids.length > 0);
        setSelectionModel(ids);
      },
      rowSelectionModel: selectionModel
    }
  );
}
function CustomToolbar(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridToolbarContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridToolbarFilterButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ImportFilter, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ExportFilter, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteButton, { selectionModel: props.selectionModel, showDeleteButton: props.showDeleteButton })
  ] });
}
const DeleteButtonStyle = styled("div")({
  color: "#f44336"
});
function DeleteButton(props) {
  const { setArrayFilter } = useArrayFilterContext();
  if (!props.showDeleteButton)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteButtonStyle, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CustomToolbarItemStyle, { direction: "row", onClick: () => {
    deleteSelectedFilter(setArrayFilter, props.selectionModel);
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "material-icons-round", children: "delete" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "선택 삭제" })
  ] }) });
}
function deleteSelectedFilter(setRows, selectionModel) {
  setRows((row) => {
    const newRow = row.filter((r) => {
      return !selectionModel.includes(r.id);
    });
    return newRow;
  });
}
function Filter() {
  const { globalSetting, dispatchGlobalSetting } = useGlobalSettingContext();
  const [advancedFilter, setAdvancedFilter] = React.useState(globalSetting.advancedFilter === "on");
  const { arrayFilter } = useArrayFilterContext();
  const { channelInfoObject, dispatchChannelInfo, channel: channel2, setChannel, User } = useChannelInfo();
  const [filterInput, setFilterInput] = React.useState(getDefaultArrayFilter());
  const [filterInputList, setFilterInputList] = React.useState([]);
  const filterInputListRef = React.useRef([]);
  const filterBroadcastChannel = React.useRef(new BroadcastChannel("ArrayFilter"));
  const messageId = React.useRef("");
  const { t: t2 } = useTranslation();
  const onPlatformChipClick = (platform) => {
    dispatchGlobalSetting({ type: "platform", value: platform });
  };
  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/setting/filter" });
  }, []);
  React.useEffect(() => {
    document.title = `${t2("setting.filter_setting")}- TBC`;
  }, []);
  React.useEffect(() => {
    const msg = {
      from: "filter",
      filter: arrayFilter,
      msgId: messageId.current
    };
    filterBroadcastChannel.current.postMessage(msg);
  }, [arrayFilter]);
  useEffect(() => {
    setAdvancedFilter((f) => globalSetting.advancedFilter === "on");
  }, [globalSetting]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ChannelInfoContext.Provider, { value: { channelInfoObject, dispatchChannelInfo, channel: channel2, setChannel, User }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Stack,
    {
      spacing: 2,
      sx: {
        minHeight: "0",
        margin: "16px"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Card,
          {
            sx: {
              padding: "16px",
              flex: "1",
              display: "flex",
              flexDirection: "column",
              overflow: "auto",
              border: "4px solid",
              borderColor: globalSetting.platform === "twitch" ? "#9147ff" : "#00ffa3e6"
            },
            className: "card",
            variant: "outlined",
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Stack,
              {
                spacing: 2,
                sx: {
                  flex: "1 1 auto"
                },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Paper$1, { sx: { p: 1, m: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", gap: 1, children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, { label: "트위치", color: globalSetting.platform === "twitch" ? "primary" : "default", onClick: () => {
                      onPlatformChipClick("twitch");
                    }, clickable: true }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, { label: "치지직", color: globalSetting.platform === "chzzk" ? "primary" : "default", onClick: () => {
                      onPlatformChipClick("chzzk");
                    }, clickable: true })
                  ] }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { variant: "h6", children: t2("setting.filter.filter_list") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(ArrayFilterList, {}),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { variant: "h6", children: t2("setting.filter.filter_add") }),
                  advancedFilter ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { variant: "subtitle2", children: t2("setting.filter.filter_add_subtitle") }) : null,
                  advancedFilter ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                    FilterInputFormList,
                    {
                      afInputRow: filterInputList,
                      setAfInputRow: setFilterInputList,
                      filterInputListRef
                    }
                  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                    FilterInputForm,
                    {
                      filterInput,
                      setFilterInput
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { variant: "h6", children: t2("setting.filter.select_badges") }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    BadgeList,
                    {
                      setAfInputRow: setFilterInputList,
                      setFilterInput
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SocialFooter, {})
      ]
    }
  ) });
}
const AlertContainerStyle = styled$1(Stack)({
  position: "fixed",
  right: "0",
  gap: "8px",
  flexDirection: "column",
  justifyContent: "flex-end",
  padding: "8px",
  zIndex: "1444"
});
function AlertContainer() {
  const { alerts } = useAlertContext();
  const alert2 = alerts.map((a) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Alert,
      {
        variant: "filled",
        severity: a.serverity,
        children: a.message
      },
      `${a.serverity}-${a.message}`
    );
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainerStyle, { direction: "row", children: alert2 });
}
const ChatDisplayMethodOptions = ["local", "remote"];
const LanguageOptions = ["ko", "en"];
const FontSizeOptions = ["small", "default", "big", "bigger"];
const PositionOptions = ["up", "down"];
const ToggleOptions = ["on", "off"];
const PlatformOptions = ["twitch", "chzzk"];
const setting$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChatDisplayMethodOptions,
  FontSizeOptions,
  LanguageOptions,
  PlatformOptions,
  PositionOptions,
  ToggleOptions
}, Symbol.toStringTag, { value: "Module" }));
function Login() {
  const auth = useAuthContext();
  const { t: t2 } = useTranslation();
  const onLoginButtonClick = () => {
    if (auth) {
      auth.toggleLogin();
    }
  };
  return typeof auth !== "undefined" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "column", spacing: 2, sx: { padding: "16px" }, children: auth && auth.authInfo.status ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", spacing: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Profile,
      {
        profileImgUrl: auth.authInfo.profileImgUrl,
        displayName: auth.authInfo.displayName,
        loginName: auth.authInfo.loginName
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "contained", onClick: onLoginButtonClick, children: t2("common.logout") })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "contained", onClick: onLoginButtonClick, children: t2("setting.login_with_twitch") }) }) : null;
}
function Setting(props) {
  const { globalSetting, dispatchGlobalSetting } = useGlobalSettingContext();
  const { t: t2 } = useTranslation();
  const handleSelectionChange = (event) => {
    const target = event.target;
    if (target.name === "language") {
      dispatchGlobalSetting({ type: "language", value: target.value });
    } else if (target.name === "position") {
      dispatchGlobalSetting({ type: "position", value: target.value });
    } else if (target.name === "chatFontSize") {
      dispatchGlobalSetting({ type: "chatFontSize", value: target.value });
    }
  };
  const handleSwitchChange = (event) => {
    const value = event.target.checked ? "on" : "off";
    const id = event.target.id;
    if (id === "dark-theme-switch") {
      dispatchGlobalSetting({ type: "darkTheme", value });
    } else if (id === "chat-time-switch") {
      dispatchGlobalSetting({ type: "chatTime", value });
    } else if (id === "player-switch") {
      dispatchGlobalSetting({ type: "player", value });
    } else if (id === "filter-mode-switch") {
      dispatchGlobalSetting({ type: "advancedFilter", value });
    }
  };
  const login = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      List,
      {
        subheader: /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubheader, { disableSticky: true, children: t2("common.login") }),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Login, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {})
  ] });
  const language = /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: t2("common.language") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Select,
      {
        labelId: "setting-category",
        name: "language",
        value: globalSetting.language,
        size: "small",
        onChange: handleSelectionChange,
        children: LanguageOptions.map((o) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: o, children: t2(`common.${o}`) }, o);
        })
      }
    ) })
  ] });
  const theme = /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: t2("setting.darkmode") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Switch,
      {
        id: "dark-theme-switch",
        checked: globalSetting.darkTheme === "on",
        onChange: handleSwitchChange
      }
    )
  ] });
  const chatFontSize = /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: t2("setting.font_size") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Select,
      {
        name: "chatFontSize",
        value: globalSetting.chatFontSize,
        size: "small",
        onChange: handleSelectionChange,
        children: FontSizeOptions.map((o) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: o, children: t2(`setting.font_size_options.${o}`) }, o);
        })
      }
    ) })
  ] });
  const position = /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: t2("setting.chat_position") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Select,
      {
        name: "position",
        value: globalSetting.position,
        size: "small",
        onChange: handleSelectionChange,
        children: PositionOptions.map((o) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: o, children: t2(`setting.chat_position_options.${o}`) }, o);
        })
      }
    ) })
  ] });
  const chatTime = /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: t2("setting.chat_time") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Switch,
      {
        id: "chat-time-switch",
        checked: globalSetting.chatTime === "on",
        onChange: handleSwitchChange
      }
    )
  ] });
  const player = /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: t2("setting.show_player") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Switch,
      {
        id: "player-switch",
        checked: globalSetting.player === "on",
        onChange: handleSwitchChange
      }
    )
  ] });
  const mode = /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, { primary: t2("setting.filter_mode.advanced") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Switch,
      {
        id: "filter-mode-switch",
        checked: globalSetting.advancedFilter === "on",
        onChange: handleSwitchChange
      }
    )
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
    props.option === "ALL" ? login : null,
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      List,
      {
        subheader: /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubheader, { disableSticky: true, children: t2("common.general") }),
        children: [
          props.option === "ALL" || props.option === "WEB_DRAWER" ? language : null,
          props.option === "ALL" || props.option === "WEB_DRAWER" || props.option === "EXT_DRAWER" ? theme : null
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        List,
        {
          subheader: /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubheader, { disableSticky: true, children: t2("common.chat") }),
          children: [
            props.option === "ALL" ? chatFontSize : null,
            props.option === "ALL" ? position : null,
            props.option === "ALL" || props.option === "WEB_DRAWER" || props.option === "EXT_DRAWER" ? chatTime : null
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        List,
        {
          subheader: /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubheader, { disableSticky: true, children: t2("common.filter") }),
          children: mode
        }
      ),
      props.option === "ALL" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          List,
          {
            subheader: /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubheader, { disableSticky: true, children: t2("common.player") }),
            children: player
          }
        )
      ] }) : null
    ] })
  ] });
}
function SettingPageDrawer(props) {
  const { t: t2 } = useTranslation();
  const navigate = useNavigate();
  const onListButtonClicked = (path) => {
    navigate(`${props.env === "Web" ? "/setting" : ""}/${path}`);
  };
  const filterListItem = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FilterAltIcon, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ListItemText,
      {
        primary: t2("setting.filter_setting")
      }
    )
  ] });
  const chatSaverListItem = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ImageIcon, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ListItemText,
      {
        primary: t2("setting.save_chat")
      }
    )
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Toolbar, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    props.env === "Extension" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { severity: "info", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: t2("alert.extensionNotice") }) }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(List, { dense: false, children: [
        props.env === "Web" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemButton, { href: "/", target: "_blank", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlayArrowIcon, {}) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ListItemText,
            {
              primary: t2("common.web_player")
            }
          )
        ] }) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButton, { onClick: () => {
          onListButtonClicked(`filter`);
        }, children: filterListItem }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemButton, { onClick: () => {
          onListButtonClicked(`chatsaver`);
        }, children: chatSaverListItem })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Setting, { option: props.env === "Web" ? "WEB_DRAWER" : "EXT_DRAWER" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Donation, {})
    ] })
  ] });
}
const drawerWidth = 310;
const MainBox = styled(Box)(({ theme }) => ({
  flexGrow: "1",
  width: `calc(100% - ${drawerWidth}px)`,
  display: "flex",
  "flexDirection": "column",
  backgroundColor: theme.palette.background.default
}));
function DrawerTemplate(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { display: "flex", height: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AppBar,
      {
        position: "fixed",
        sx: {
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` }
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Toolbar, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              color: "inherit",
              "aria-label": "open drawer",
              edge: "start",
              onClick: handleDrawerToggle,
              sx: { mr: 2, display: { sm: "none" } },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuIcon, {})
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { variant: "h6", noWrap: true, component: "div", sx: { flexGrow: 1 }, children: props.title })
        ] })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        component: "nav",
        sx: { width: { sm: drawerWidth }, flexShrink: { sm: 0 } },
        "aria-label": "mailbox folders",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Drawer,
            {
              variant: "temporary",
              open: mobileOpen,
              onClose: handleDrawerToggle,
              ModalProps: {
                keepMounted: true
              },
              sx: {
                display: { xs: "block", sm: "none" },
                "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth }
              },
              children: props.drawer
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Drawer,
            {
              variant: "permanent",
              sx: {
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth }
              },
              open: true,
              children: props.drawer
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(MainBox, { component: "main", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Toolbar, {}),
      props.children
    ] })
  ] });
}
function useAlert() {
  const [alerts, setAlerts] = React.useState([]);
  const [times, setTimes] = React.useState([]);
  const addAlert = (alert2) => {
    setAlerts((alerts2) => {
      if (alerts2.some((a) => checkAlertDuplicate(a, alert2))) {
        return alerts2;
      }
      return [...alerts2, alert2];
    });
    return;
  };
  const checkAlertDuplicate = (alert_1, alert_2) => {
    return alert_1.message === alert_2.message && alert_1.serverity === alert_2.serverity;
  };
  const shiftAlert = () => {
    setAlerts((alerts2) => {
      alerts2.shift();
      return [...alerts2];
    });
  };
  React.useEffect(() => {
    if (alerts.length === 0) {
      times.forEach((t2) => {
        clearTimeout(t2);
      });
    }
    if (alerts.length > 4) {
      shiftAlert();
    }
  }, [alerts]);
  React.useEffect(() => {
    const timeId = window.setTimeout(() => {
      if (alerts.length <= 0)
        return;
      shiftAlert();
      clearTimeout(timeId);
    }, 4e3);
    setTimes([...times, timeId]);
  }, [alerts]);
  return { alerts, setAlerts, addAlert };
}
function useArrayFilter() {
  const isIframe = inIframe();
  const localArrayFilter = JSON.parse(isIframe ? "[]" : localStorage.getItem("tbc-filter") || "[]");
  const [arrayFilter, setArrayFilter] = React.useState(localArrayFilter);
  const arrayFilterRef = React.useRef([]);
  const { addAlert } = useAlertContext();
  const { t: t2 } = useTranslation();
  useEffect(() => {
    arrayFilterRef.current = arrayFilter;
  }, [arrayFilter]);
  const addArrayFilter = (newFilters) => {
    for (let newFilter of newFilters) {
      const empty = newFilter.filters.some((row) => row.value === "");
      if (empty) {
        addAlert({
          message: t2("alert.no_value_filter"),
          serverity: "warning"
        });
        return false;
      }
      setArrayFilter((afLists) => {
        for (let af of afLists) {
          if (arrayFiltersEqual(af.filters, newFilter.filters) && af.platform === newFilter.platform) {
            addAlert({
              message: t2("alert.filter_already_exist"),
              serverity: "warning"
            });
            return afLists;
          }
        }
        return [...afLists, newFilter];
      });
    }
    return true;
  };
  const checkFilter = (chat2, chatInfoObject) => {
    if (typeof arrayFilterRef.current === "undefined" || arrayFilterRef.current.length === 0)
      return false;
    let res = false;
    for (let arrayFilter2 of arrayFilterRef.current) {
      const filterMatched = arrayFilter2.filters.every((filter2) => {
        let filterMatchedRes = false;
        if (filter2.type === "sleep") {
          return filterMatchedRes;
        }
        if (filter2.category === "badge") {
          if (typeof chatInfoObject === "undefined") {
            filterMatchedRes = chat2.badges.some((badge_uuid) => {
              return badge_uuid === filter2.value;
            });
          } else {
            filterMatchedRes = chat2.badges.some((badge_str) => {
              const badge = chatInfoObject.channelBadges.get(badge_str) || chatInfoObject.globalBadges.get(badge_str);
              if (!badge)
                return false;
              const badge_uuid = new URL(badge.image_url_1x).pathname.split("/")[3];
              return badge_uuid === filter2.value;
            });
          }
        } else if (filter2.category === "name") {
          filterMatchedRes = chat2.loginName.toLowerCase() === filter2.value.toLowerCase() || chat2.nickName.toLowerCase() === filter2.value.toLowerCase();
        } else if (filter2.category === "keyword") {
          filterMatchedRes = chat2.textContents.some((text) => text !== null ? text.includes(filter2.value) : false);
        }
        if (filter2.type === "exclude") {
          filterMatchedRes = !filterMatchedRes;
        }
        return filterMatchedRes;
      });
      if (filterMatched) {
        if (arrayFilter2.filterType === "include") {
          res = true;
        } else if (arrayFilter2.filterType === "exclude") {
          res = false;
          break;
        } else if (arrayFilter2.filterType === "sleep")
          ;
      }
    }
    return res;
  };
  return { arrayFilter, arrayFilterRef, setArrayFilter, addArrayFilter, checkFilter };
}
function useAuth() {
  const [authInfo, setAuthInfo] = React.useState({
    accessToken: "",
    id: "",
    displayName: "",
    profileImgUrl: "",
    loginName: "",
    status: null
  });
  const twitchAPI2 = useTwitchAPIContext();
  const fetchToken = async () => {
    const { data } = await axios.post(`/auth/token`);
    return data;
  };
  const { data: Token } = useQuery(
    ["Token"],
    () => fetchToken()
  );
  const { data: loginUser, error: userError } = useQuery(
    ["loginUser"],
    () => twitchAPI2.fetchUser(),
    {
      enabled: typeof Token !== "undefined" && Token.status
    }
  );
  React.useEffect(() => {
    if (Token && !Token.status || userError) {
      setAuthInfo((auth) => {
        const newAuth = { ...auth };
        newAuth.status = Token.status;
        return newAuth;
      });
    }
    if (!loginUser)
      return;
    setAuthInfo({
      accessToken: Token.access_token,
      id: loginUser.data[0].id,
      loginName: loginUser.data[0].login,
      displayName: loginUser.data[0].display_name,
      profileImgUrl: loginUser.data[0].profile_image_url,
      status: Token.status
    });
  }, [loginUser, userError, Token]);
  const reqLogin = () => {
    const params = new URLSearchParams();
    params.append("cstate", getRandomString());
    params.append("page", "/");
    window.location.replace(`/auth/login?${params}`);
  };
  const reqLogout = () => {
    const params = new URLSearchParams();
    params.append("page", "/");
    window.location.replace(`/auth/logout?${params}`);
  };
  const status = () => {
    const token = authInfo.accessToken;
    return token !== "";
  };
  const toggleLogin = () => {
    if (!status()) {
      reqLogin();
    } else {
      reqLogout();
    }
  };
  return { authInfo, setAuthInfo, status, toggleLogin };
}
function useChatSaverBroadcaster(cloneChatList, channel2, channelInfo, type, env) {
  const ChatListBroadcastChannel = React.useRef(new BroadcastChannel("ChatList"));
  const ChannelInfoBroadcastChannel = React.useRef(new BroadcastChannel("ChannelInfoList"));
  const cloneChatListRef = React.useRef(cloneChatList);
  const channelRef = React.useRef(channel2);
  const channelInfoRef = React.useRef(channelInfo);
  const chatListId = React.useRef(nanoid());
  const onMessage = (e) => {
    if (e.data.sender !== "extension")
      return;
    const dataType = e.data.type;
    const dataValue = e.data.value;
    if (dataType === "CHATSAVER_REQUEST_CHANNEL_INFO") {
      window.postMessage({
        sender: "wtbc",
        type: "CHATSAVER_RESPONSE_CHANNEL_INFO",
        value: channelInfoRef.current
      }, "*");
    } else if (dataType === "CHATSAVER_REQUEST_CHAT_LIST") {
      if (!channelRef.current || !channelInfoRef.current)
        return;
      const channel22 = dataValue.value ? dataValue.value : "";
      if (typeof channel22 !== "undefined" && channel22 !== "" && channelRef.current.value !== channel22)
        return;
      window.postMessage({
        sender: "wtbc",
        type: "CHATSAVER_RESPONSE_CHAT_LIST",
        value: {
          chatListId: chatListId.current,
          chatList: cloneChatListRef.current,
          chatListType: type,
          channel: channelRef.current,
          channelInfo: channelInfoRef.current
        }
      });
    }
  };
  React.useEffect(() => {
    if (env !== "Extension")
      return;
    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, []);
  React.useEffect(() => {
    if (env !== "Web")
      return;
    ChannelInfoBroadcastChannel.current.onmessage = (msg) => {
      if (typeof channelInfoRef.current === "undefined")
        return;
      if (msg.messageType === "CHATSAVER_REQUEST_CHANNEL_INFO") {
        ChannelInfoBroadcastChannel.current.postMessage({
          messageType: "CHATSAVER_RESPONSE_CHANNEL_INFO",
          channelInfo: channelInfoRef.current
        });
      }
    };
    ChatListBroadcastChannel.current.onmessage = (msg) => {
      if (!channelRef.current || !channelInfoRef.current)
        return;
      const channel22 = msg.channel ? msg.channel.value : "";
      if (msg.messageType === "CHATSAVER_REQUEST_CHAT_LIST") {
        if (typeof msg.channel !== "undefined" && channel22 !== "" && channelRef.current.value !== channel22)
          return;
        ChatListBroadcastChannel.current.postMessage({
          messageType: "CHATSAVER_RESPONSE_CHAT_LIST",
          chatListId: chatListId.current,
          chatList: cloneChatListRef.current,
          chatListType: type,
          channel: channelRef.current,
          channelInfo: channelInfoRef.current
        });
      }
    };
  }, []);
  React.useEffect(() => {
    cloneChatListRef.current = cloneChatList;
    channelRef.current = channel2;
    channelInfoRef.current = channelInfo;
  }, [cloneChatList, channel2, channelInfo]);
}
function settingReducer(state, action) {
  const copyState = { ...state };
  switch (action.type) {
    case "SET_MULTIPLE":
      return Object.assign(copyState, action.value);
    case "language":
      copyState.language = action.value;
      return copyState;
    case "chatFontSize":
      copyState.chatFontSize = action.value;
      return copyState;
    case "darkTheme":
      copyState.darkTheme = action.value;
      return copyState;
    case "position":
      copyState.position = action.value;
      return copyState;
    case "chatTime":
      copyState.chatTime = action.value;
      return copyState;
    case "player":
      copyState.player = action.value;
      return copyState;
    case "chatDisplayMethod":
      copyState.chatDisplayMethod = action.value;
      return copyState;
    case "advancedFilter":
      copyState.advancedFilter = action.value;
      return copyState;
    case "pointBoxAuto":
      copyState.pointBoxAuto = action.value;
      return copyState;
    case "maximumNumberChats":
      copyState.maximumNumberChats = action.value;
      return copyState;
    case "platform":
      copyState.platform = action.value;
      return copyState;
    case "miniChatTime":
      copyState.miniChatTime = action.value;
      return copyState;
    case "miniLanguage":
      copyState.miniLanguage = action.value;
      return copyState;
    case "miniFontSize":
      copyState.miniFontSize = action.value;
      return copyState;
    default:
      throw new Error("Unhandled action");
  }
}
const setting$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  settingReducer
}, Symbol.toStringTag, { value: "Module" }));
function getThemePrefer() {
  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return true;
  }
  return false;
}
function useGlobalSetting(env, extStorageReadOnly = true) {
  const isIframe = inIframe();
  const localGlobalSetting = isIframe ? null : getLocalStorageObject("globalSetting");
  const defaultGlobalSetting = {
    language: ["ko", "ko-kr"].includes(navigator.language.toLowerCase()) ? "ko" : "en",
    chatFontSize: "default",
    darkTheme: getThemePrefer() ? "on" : "off",
    position: "up",
    chatTime: "on",
    player: "on",
    maximumNumberChats: 100,
    advancedFilter: "off"
  };
  useState(false);
  const [globalSetting, dispatchGlobalSetting] = useReducer(settingReducer, env === "Extension" ? {} : localGlobalSetting || defaultGlobalSetting);
  return { globalSetting, dispatchGlobalSetting };
}
function useTwitchAPI(dev) {
  const instance = axios.create({
    baseURL: `https://${dev ? "dev." : ""}badgecollector.dev`
  });
  const fetchUser = React.useCallback(async (paramType, ...reqParams) => {
    let params = new URLSearchParams();
    reqParams.forEach((param) => {
      if (param && param !== "") {
        params.append(paramType === "login" ? "login" : "id", param);
      }
    });
    const { data } = await instance.get(`/api/users?${params}`);
    return data;
  }, []);
  const fetchFollowedStreams = React.useCallback(async (userId, cursor) => {
    const params = new URLSearchParams();
    params.append("user_id", userId);
    params.append("first", "10");
    if (cursor && cursor !== "")
      params.append("after", cursor);
    const { data } = await instance.get(`/api/streams/followed?${params}`);
    return data;
  }, []);
  const fetchChannelChatBadges = React.useCallback(async (broadcaster_id) => {
    const url = `/api/chat/badges?broadcaster_id=${broadcaster_id}`;
    const { data } = await instance.get(url);
    return badgeDataToMap(data);
  }, []);
  const fetchGlobalChatBadges = React.useCallback(async () => {
    const { data } = await instance.get("/api/chat/badges/global");
    return badgeDataToMap(data);
  }, []);
  const fetchVideos = React.useCallback(async (id) => {
    const params = new URLSearchParams();
    params.append("id", id);
    const { data } = await instance.get(`/api/videos?${params}`);
    return data;
  }, []);
  const fetchClips = React.useCallback(async (clipId) => {
    const params = new URLSearchParams();
    params.append("id", clipId);
    const { data } = await instance.get(`/api/clips?${params}`);
    return data;
  }, []);
  const fetchEmoteSets = React.useCallback(async (emote_sets_id) => {
    const url = "/api/chat/emotes/set?";
    const emote_sets = /* @__PURE__ */ new Map();
    const params = new URLSearchParams();
    for (let i = 0; i < emote_sets_id.length; i++) {
      params.append("emote_set_id", emote_sets_id[i]);
    }
    const { data } = await instance.get(url + params);
    data.data.forEach((e) => {
      emote_sets.set(e.name, e);
    });
    return emote_sets;
  }, []);
  const fetchCheermotes = React.useCallback(async (broadcaster_id) => {
    const url = `/api/bits/cheermotes?broadcaster_id=${broadcaster_id}`;
    const { data } = await instance.get(url);
    let cmMap = /* @__PURE__ */ new Map();
    for (let c = 0; c < data.data.length; c++) {
      let cd = data.data[c];
      cmMap.set(cd.prefix, cd.tiers);
    }
    return cmMap;
  }, []);
  const fetchUsersFollows = React.useCallback(async (from_id, to_id) => {
    const { data } = await instance.get(`/api/users/follows?from_id=${from_id}&to_id=${to_id}`);
    return data;
  }, []);
  const badgeDataToMap = React.useCallback((badges) => {
    const badge_data = badges.data;
    let badges_map = /* @__PURE__ */ new Map();
    for (let b = 0; b < badge_data.length; b++) {
      let bd = badge_data[b];
      for (let v = 0; v < bd.versions.length; v++) {
        const badge_raw = `${bd.set_id}/${bd.versions[v].id}`;
        badges_map.set(badge_raw, bd.versions[v]);
      }
    }
    return badges_map;
  }, []);
  return {
    fetchUser,
    fetchFollowedStreams,
    fetchChannelChatBadges,
    fetchGlobalChatBadges,
    fetchVideos,
    fetchClips,
    fetchEmoteSets,
    fetchCheermotes,
    fetchUsersFollows
  };
}
function useChzzkAPI() {
  const instance = axios.create({
    baseURL: `https://chzzk.badgecollector.dev`
  });
  const fetchBadges = React.useCallback(async () => {
    const { data } = await instance.post(`/badges`);
    return data;
  }, []);
  return {
    fetchBadges
  };
}
const chat = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const chatInfoObjects = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const BadgeChannelArr = ["global", "channel"];
const channel = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BadgeChannelArr
}, Symbol.toStringTag, { value: "Module" }));
const TypeArr = ["include", "exclude", "sleep"];
const ChannelChatBadgesCategoryArr = ["bits", "subscriber"];
const twitchAPI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChannelChatBadgesCategoryArr,
  TypeArr
}, Symbol.toStringTag, { value: "Module" }));
const chzzkAPI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const alert$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const broadcastChannelInterface = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const client = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const tmi_system$1 = {
  server_connecting: "Connecting chat server..",
  server_connected: "Connected chat server.",
  channel_joined: "Joined in #{{channel}}.",
  emote_enabled: "Emote-only mode enabled.",
  emote_disabled: "Emote-only mode disabled.",
  follower_only_enabled: "{{length}} follow-only chat enabled.",
  follower_only_disabled: "Followed-only mode disabled.",
  slow_mode_enabled: "{{length}} slow mode enabled",
  slow_mode_disabled: "Slow mode disabled",
  all_chat_removed: "All chats removed.",
  temporary_timeout: "You are temporarily sent off for {{duration}} seconds.",
  subscriber_only_enabled: "Subscriber-only mode enabled.",
  subscriber_only_disabled: "Subscriber-only mode disabled.",
  raid: "{{username}} is rading {{channel}} with {{viewers}} raiders!",
  host: "Hosting {{target}}"
};
const alert$1 = {
  no_value_filter: "No values in filter.",
  filter_already_exist: "Filter already exist.",
  filter_updated: "Filter has been updated.",
  no_selected_chat: "No chats selected.",
  no_connect_channel: "No channels are connected.",
  version_mismatch: "Extension Version mismatch. Unexpected errors may occur.",
  network_error: "Request failed.",
  channel_not_found: "Channel info not found.",
  notice_1: "If the filter does not work properly, please refer to the link below.",
  extensionNotice: "This is the extension settings page. Does not apply to web version."
};
const common$1 = {
  en: "English",
  ko: "한국어",
  setting: "Setting",
  general: "General",
  login: "Login",
  logout: "Log Out",
  filter: "Filter",
  condition: "Condition",
  badge: "Badge",
  channel: "Channel",
  channel_name: "Channel Name",
  channel_select: "Select Channel",
  note: "Note",
  badge_name: "Badge Name",
  global: "Global",
  add_selected: "Add Selected",
  search: "Search",
  add_filter: "Add Filter",
  add_filter_element: "Add Filter Element",
  filter_export: "Export Filter",
  filter_import: "Import Filter",
  announcement: "Announcement",
  category: "Category",
  type: "Type",
  filter_type: "Filter Type",
  chat: "Chat",
  player: "Player",
  language: "Language",
  donation: "Donation",
  web_player: "Web Player",
  send_message: "Send a message",
  add_filter_elements: "Add Filter Elements",
  nickname: "Nickname",
  keyword: "Keyword",
  value: "Value",
  remove: "Remove",
  cancel: "Cancel",
  save: "Save",
  join: "Join",
  chat_list: "Chat Lists",
  recent_channel: "Recent Channel",
  no_list: "No Lists.",
  online: "Online",
  error: "An error has occurred.",
  show_more: "Show More",
  live: "Live",
  replay: "Replay",
  noticeBeta: "This is a beta version. Unexpected errors may occur.",
  tier: "Tier",
  months: "Months",
  followSince: "Following Since {{date}}",
  subscribeSince: "Subbed for {{month}} Months",
  channelNotFound: "Channel name not found.",
  requestChannelName: "Please enter the channel name directly.",
  channelName: "Channel Name",
  confirm: "Confirm",
  document: "Documentation",
  welcome_1: "Thank you for installing the extension.",
  welcome_2: "Please read the <1>document</1> before using the extension.",
  nofityAdsense: "Google Adsense advertisements will be displayed at the bottom of the instruction page, provided to generate revenue for the program."
};
const filter$1 = {
  category: {
    include: "Include",
    exclude: "Exclude",
    sleep: "Sleep"
  },
  type: {
    badge: "Badge",
    name: "Name",
    keyword: "Keyword"
  }
};
const setting$1 = {
  filter_setting: "Filter Setting",
  channel_setting: "Channel Setting",
  save_chat: "Save Chats As Image",
  login_with_twitch: "Login with Twitch",
  darkmode: "Dark Mode",
  font_size: "Font Size",
  font_size_options: {
    small: "Small",
    "default": "Default",
    big: "Big",
    bigger: "Bigger"
  },
  chat_position: "Chat Position",
  chat_position_options: {
    up: "Up",
    down: "Down"
  },
  chat_time: "Chat Time",
  show_player: "Show Player",
  filter: {
    filter_list: "Filter List",
    filter_add: "Add New Filter",
    filter_add_subtitle: "Filters chats that satisfy all the conditions of the added filter element.",
    select_badges: "Select Badges"
  },
  filter_mode: {
    advanced: "Advenced Settings"
  }
};
const en = {
  tmi_system: tmi_system$1,
  alert: alert$1,
  common: common$1,
  filter: filter$1,
  setting: setting$1
};
const tmi_system = {
  server_connecting: "채팅 서버에 연결 중 입니다..",
  server_connected: "채팅 서버에 연결되었습니다.",
  channel_joined: "#{{channel}} 채널에 입장했습니다.",
  emote_enabled: "이모티콘 전용 채팅이 활성화되었습니다.",
  emote_disabled: "이모티콘 전용 채팅이 비활성화되었습니다.",
  follower_only_enabled: "팔로우 전용 채팅이 {{length}} 동안 활성화되었습니다.",
  follower_only_disabled: "팔로우 전용 채팅이 비활성화되었습니다.",
  slow_mode_enabled: "슬로우 모드가 {{length}} 로 설정되었습니다.",
  slow_mode_disabled: "슬로우 모드가 비활성화되었습니다.",
  all_chat_removed: "채팅이 모두 삭제되었습니다.",
  temporary_timeout: "{{duration}} 동안 임시 퇴장되었습니다.",
  subscriber_only_enabled: "구독자 전용 모드가 활성화되었습니다.",
  subscriber_only_disabled: "구독자 전용 모드가 비활성화되었습니다.",
  raid: "{{username}} 님이 {{viewers}}명과 함께 {{channel}} 채널을 레이드합니다!",
  host: "{{target}} 호스팅 중."
};
const alert = {
  no_value_filter: "필터에 내용이 없습니다.",
  filter_already_exist: "이미 존재하는 필터입니다.",
  filter_updated: "필터가 업데이트되었습니다.",
  no_selected_chat: "선택된 채팅이 없습니다.",
  no_connect_channel: "연결된 채널이 없습니다.",
  version_mismatch: "확장 프로그램의 버전이 일치하지 않습니다. 예상치 못한 오류가 발생할 수 있습니다.",
  network_error: "요청이 실패했습니다.",
  notice_1: "필터 기능이 제대로 동작하지 않는 경우 아래 링크를 참고해주세요.",
  channel_not_found: "채널 정보를 찾을 수 없습니다.",
  extensionNotice: "확장 프로그램 설정 페이지입니다. 웹 버전에는 적용되지 않습니다."
};
const common = {
  en: "English",
  ko: "한국어",
  setting: "설정",
  general: "일반",
  login: "로그인",
  logout: "로그아웃",
  filter: "필터",
  condition: "조건",
  badge: "배지",
  channel: "채널",
  channel_name: "채널 이름",
  channel_select: "채널 선택",
  note: "비고",
  badge_name: "배지 이름",
  global: "글로벌",
  add_selected: "선택 추가",
  search: "검색",
  add_filter: "필터 추가",
  add_filter_element: "필터 요소 추가",
  filter_export: "필터 내보내기",
  filter_import: "필터 가져오기",
  announcement: "공지",
  category: "카테고리",
  type: "타입",
  filter_type: "필터 카테고리",
  chat: "채팅",
  player: "플레이어",
  language: "언어",
  donation: "후원",
  web_player: "웹 플레이어",
  send_message: "메시지 보내기",
  add_filter_elements: "필터 요소를 추가하세요.",
  nickname: "닉네임",
  keyword: "키워드",
  value: "내용",
  remove: "삭제",
  cancel: "취소",
  save: "저장",
  join: "참가",
  chat_list: "채팅 목록",
  recent_channel: "최근 채널",
  no_list: "목록이 없습니다.",
  online: "온라인",
  error: "오류가 발생했습니다.",
  show_more: "더 보기",
  live: "생방송",
  replay: "다시보기",
  noticeBeta: "베타 버전입니다. 예상치 못한 오류가 발생할 수 있습니다.",
  tier: "티어",
  months: "개월",
  followSince: "{{date}}부터 팔로우 중",
  subscribeSince: "{{month}}개월 동안 구독 중",
  channelNotFound: "채널 이름을 찾을 수 없습니다.",
  requestChannelName: "채널 이름을 직접 입력해주세요.",
  channelName: "",
  confirm: "확인",
  document: "설명서",
  welcome_1: "확장 프로그램을 설치해주셔서 감사합니다.",
  welcome_2: "사용 전에는 반드시 <1>설명서</1>를 읽어보시기 바랍니다.",
  nofityAdsense: "설명서 페이지 하단에 Google Adsense 광고가 표시됩니다. 이 광고는 프로그램의 수익 창출을 위해 제공됩니다."
};
const filter = {
  category: {
    include: "포함",
    exclude: "제외",
    sleep: "꺼짐"
  },
  type: {
    badge: "배지",
    name: "이름",
    keyword: "키워드"
  }
};
const setting = {
  filter_setting: "필터 설정",
  channel_setting: "채널 설정",
  save_chat: "채팅 이미지 저장",
  login_with_twitch: "트위치로 로그인",
  darkmode: "어두운 테마",
  font_size: "글자 크기",
  font_size_options: {
    small: "작게",
    "default": "기본값",
    big: "크게",
    bigger: "더 크게"
  },
  chat_position: "채팅창 위치",
  chat_position_options: {
    up: "위",
    down: "아래"
  },
  chat_time: "채팅 시간",
  show_player: "플레이어 보이기",
  filter: {
    filter_list: "필터 목록",
    filter_add: "새 필터 추가",
    filter_add_subtitle: "추가된 필터 요소의 조건을 모두 만족하는 채팅을 필터링합니다.",
    select_badges: "배지 선택"
  },
  filter_mode: {
    advanced: "고급 설정"
  }
};
const ko = {
  tmi_system,
  alert,
  common,
  filter,
  setting
};
i18n.use(LanguageDetector).use(initReactI18next).init({
  fallbackLng: "en",
  resources: {
    ko: {
      translation: ko
    },
    en: {
      translation: en
    }
  }
});
export {
  AlertContainer,
  alert$2 as AlertInterface,
  broadcastChannelInterface as BroadcastChannelInterface,
  channel as ChannelInterface,
  ChatContainer,
  chatInfoObjects as ChatInfoObjectsInterface,
  chat as ChatInterface,
  ChatSaver,
  ChatSaverDialog,
  ChatSaverWeb,
  chzzkAPI as ChzzkAPIInterface,
  client as ClientInterface,
  common$2 as Common,
  index as Context,
  Donation,
  DrawerTemplate,
  Filter,
  filter$2 as FilterInterface,
  Setting,
  setting$3 as SettingInterface,
  SettingPageDrawer,
  setting$2 as SettingReducer,
  SocialFooter,
  twitchAPI as TwitchAPIInterface,
  utils as Utils,
  default2 as i18n,
  useAlert,
  useArrayFilter,
  useAuth,
  useChannelInfo,
  useChatSaverBroadcaster,
  useChzzkAPI,
  useCustomTheme,
  useGlobalSetting,
  useReadableColor,
  useTwitchAPI
};
